export const translations = [
    "SalesEmails",
    "WasGibtsNeues",
    "NeustartTutorial",
    "HowToVideos",
    "Hilfe",
    "Dashboard",
    "Löschen",
    "Abbrechen",
    "Fertig",
    "Ok",
    "Bedingung",
    "Ja",
    "Nein",
    "gleich",
    "ungleich",
    "größergleich",
    "kleinergleich",
    "keineBedingung",
    "Antwort",
    "keineAntworten",
    "Aktion",
    "SchwellenwertOderLevel",
    "Verbindenmit",
    "VerbindenMitMussGefülltsein",
    "FrageFürDieBewertungHinzufügen",
    "GebenSieEinenTitelFürDieFeststellungsprüfungAn",
    "GebenSieEineBewertungsfrageEin",
    "Frage",
    "InterviewBeendet",
    "RichtigeAntwort",
    "FalscheAntwort",
    "WerkzeugeBearbeiten",
    "TestGenerieren",
    "UpdateTest",
    "AtLeastThreeJobs",
    "AssessmentTestErstellen",
    "AssessmentTitle",
    "DerTitelExistiertBereitsErstellenSieEinenEinzigartigenTitel",
    "BasicWorkflows",
    "checkLogsForTranslation",
    "UseWorkflow",
    "AdvancedWorkflows",
    "NeuenWorkflowErstellen",
    "EmailSendenBeiBewerbungseingang",
    "sendeEineEmailWennBineBewerbungEingegangenIst",
    "EmailSendenWennBewerberImOnboardingIst",
    "sendeEineEmailWennSichDerBewerbendeImOnboardingBefindet",
    "ProfilAnKundeVerschicken",
    "sendeEineEmailMitDemBewerberprofilAnDenKunden",
    "ProfilAnDisponentVerschicken",
    "sendeEineEmailMitDemBewerberprofilAnDenDisponenten",
    "MatcheBewerberAufKriteriumSendeNotizAnDisponenten",
    "SchickeInformationenNachErfolgreichemInterview",
    "schickeSpezifischeInformationenZumBewerberDamitManWeißWieEsWeitergeht",
    "SchickeDatenAnSchnittstellen",
    "updateInformationenInATSSystem",
    "fahreEchtzeitUpdatesInDeinemATSSystem",
    "updateInformationenInERPSystem",
    "fahreEchtzeitUpdatesInDeinemERPSystem",
    "leiteWeiterZurWebseite",
    "leiteDiePersonWeiterZuEinerWebseite",
    "ProfilErstellenNachBewerbungseingangOhneInterview",
    "erstelleEinProfilOhneInterview",
    "ProfilMatchenUndVersendenAKunden",
    "ProfilMatchenUndVersendenAnDisponent",
    "matcheUndVersendeDasProfilAnDenKunden",
    "AnrufSendenWennBewerberInsichBeworbenHat",
    "sendeEinenAnrufWennDerBewerbendeDasOnboardingBeendetHat",
    "SMSSendenWennBewerberInSichBeworbenHat",
    "sendeEineSMSWennDerBewerbendeDasOnboardingErfolgreichBeendetHat",
    "SendeDankesmailAnBewerber",
    "sendetDankesmailAnBewerberNachDemBewerbungsprozess",
    "SendeVertragskopieAnBewerber",
    "sendetEineKopieDesVertragsAnDenBewerber",
    "TerminÜberCalendlyBuchen",
    "DerBewerberKannEinenTerminÜberCalendlyBeiIhnenBuchen",
    "zumZeitpunkt",
    "vierhDanach",
    "vierundzwanzighDanach",
    "achtundvierzighDanach",
    "benutzerdefinierteZeit",
    'BenutzerdefinierteZeit',
    "nichtWiederholen",
    "wiederholen",
    "every",
    "after",
    "PleaseEnteraNumberFrom1to30",
    "täglich",
    "wöchentlich",
    "monatlich",
    "mon",
    "di",
    "mi",
    "do",
    "fr",
    "sa",
    "so",
    "Bewerberprofil",
    "BewerberprofilFürKunden",
    "BewerberprofilFürDisponentUndMatching",
    "Vertragsdokumente",
    "attachments",
    "dynamicAttachments",
    "API",
    "Flowchartknotenpunkt",
    "OnboardingBeendet",
    "WiederkehrenderWorkflow",
    "VertragUnterschrieben",
    "mandantenMatchingEinzeln",
    "geoMappingEinzeln",
    "geoMappingMehrfach",
    "alleAusführen",
    "KriteriumErfüllt",
    "mehrereKriterienErfüllt",
    "Disponent",
    "Kunde",
    "Workflows",
    "Name",
    "Inhalt",
    "Medium",
    "Zyklus",
    "zumEreigniszeitpunkt",
    "nach4Stunden",
    "nach24Stunden",
    "nach48Stunden",
    "jederzeit",
    "AktionAuswählen",
    "BewerberAusgewählt",
    "WorkflowAnwenden",
    "BestehendeWorkflowDatenWerdenÜberschrieben",
    "NeuKontaktieren",
    "BewerberDuplizierenUndNeuZuordnen",
    "WorkflowAuswählen",
    "StellenausschreibungAuswählen",
    "InterviewAuswählen",
    "Ausführen",
    "AktionAusführen",
    "DerAusgewählteWorkflowWirdAufAlleBewerberAngewendet",
    "FürJedenDerBewerberWirdEineKopieErstellt",
    "BitteWählenSieAlleErforderlichenOptionenAus",
    "WorkflowEdit",
    "ChosenWorkflows",
    "StatusDesWorkflow",
    "UntergeordneteWorkflows",
    "UntergeordneteMatchingOptionen",
    "untergeordnet",
    "übergeordnet",
    "WorkflowName",
    "EventTypes",
    "bitteAuswählen",
    "BeschreibeDenProzess",
    "DateAndTime",
    "Repeat",
    "Every",
    "days",
    "weeks",
    "months",
    "End",
    "repeatations",
    "WennDasPassiert",
    "dannSchickeDiesesMedium",
    "Informationen",
    "InformationenAnpassen",
    "EMailTextAnpassen",
    "Betreff",
    "Nachricht",
    "Anhänge",
    "BetreffFallsLleerDannWirdDerBetreffPassendDynamischGesetzt",
    "DateiWählen",
    "dynamischeAnhänge",
    "NachrichtOptional",
    "dynamischenAnhangAuswählen",
    "VorlageWählenOptional",
    "DokumentNameFestelegen",
    "DokumentHochladenNurDOCX",
    "dynamischeAPIDaten",
    "anDieseEmpfänger",
    "EMailAdresseDesEmpfängersUndAufPLUSklicken",
    "Landesvorwahl",
    "Telefonnummer",
    "DieEMailExistiertBereits",
    "DieTelefonnummerExistiertBereits",
    "KalenderLink",
    "KalenderLinkEinfügen",
    "Speichern",
    "CustomizeReminderEmail",
    "CustomizeReminderSMS",
    "EMailBetreff",
    "HierKannDerStandardtextDesEMailBetreffsEingegebenWerden",
    "EMailText",
    "Vorname",
    "Nachname",
    "defaultJobOfferLanguage",
    "Firmenname",
    "Link",
    "HierKannDerStandardtextZurEMailKontaktierungEingegebenWerden",
    "SMSText",
    "HierKannDerStandardtextZurSMSKontaktierungEingegebenWerden",
    "conditionalFlowchart",
    "Lesen",
    "Messages",
    "Variables",
    "NeueNachrichtHinzufügen",
    "neueNachricht",
    "VariabelMatching",
    "VariableAusVertrag",
    "Konfigurieren",
    "VertragHinzufügen",
    "Vetragsname",
    "ErstelltAm",
    "WähleEineDatei",
    "aufCVAnalyseSchalten",
    "aufVertragsAnalyseSchalten",
    "DragAndDropDateiHier",
    "Erklärungen",
    "MONADashboard",
    "logout",
    "aktuellerMonat",
    "BewerberGesamt",
    "ZeitDisponent",
    "Minuten",
    "ZeitMONA",
    "ZeitGespart",
    "GeldDisponent",
    "GeldGespart",
    "loadingText",
    "Bewerber",
    "MaxLimit",
    "BewerberDoppelpunkt",
    "ÜbrigeBewerber",
    "ÜbrigeBewerberDoppelpunkt",
    "RemainingContigentsPerMonth",
    "NoDataAvailable",
    "FinalRemainingContigents",
    "Month",
    "RemainingNumberOfApplicants",
    "ÜbersichtDerBewerber",
    "Tage",
    "Gesamt",
    "SiebenTage",
    "VierzehnTage",
    "DreißigTage",
    "EmailSMSAnrufe",
    "bisherVerschickt",
    "maximalVerfügbar",
    "WorkflowsInNutzung",
    "möglicheWorkflows",
    "NachrichtBearbeiten",
    "Antwortmöglichkeiten",
    "Texteingabe",
    "InfoNachricht",
    "JaNeinFrage",
    "MultiAntwort",
    "SingleAntwort",
    "nurSpracheingabe",
    "DateiHochladen",
    "KalenderEingabe",
    "TerminWorkflow",
    "SelectATerminWorkflow",
    "HelpSetTerminWorkflow",
    "SingleDate",
    "RangeDate",
    "SingleChoice",
    "DieAntwortExistiertBereits",
    "SendenSieUnsIhreFragenKommentareUndIdeen",
    "damitWirStetigDieMONAEngineVerbessernKönnen",
    "SupportGesprächVereinbaren",
    "SupportTeam",
    "TelefonSupport",
    "EMailSupport",
    "IhrName",
    "IhreEMailAdresse",
    "IhreNachricht",
    "KategorieOptional",
    "Stellenanzeigen",
    "Kandidaten",
    "Einstellungen",
    "TypOptional",
    "FehlerMelden",
    "FunktionVorschlagen",
    "Sonstiges",
    "IhreTelefonnummerOptional",
    "OffeneTickets",
    "User",
    "EMail",
    "NachrichtDoppelpunkt",
    "Status",
    "Generieren",
    "Text",
    "TextDeutsch",
    "Avatar",
    "Sprache",
    "Titel",
    "GehörtZu",
    "StellenanzeigeErstellen",
    "Beschreibung",
    "Erklärung",
    "HierErklärenWirDirWieDuEineStellenanzeigeErstellenKannst",
    "UmEineStellenanzeigeZuErstellenBefolgeBitteDieFolgenenSchritteSchritt1",
    "WillkommenBeiDenHowTos",
    "HierFindestDuAllerleiNützlicheInformationenÜberDieMONAPlattform",
    "HerzlichWillkommen",
    "NutzeGerneDieSuchfunktionObenOderKlickeDichDurchDasMenüLinksWirFreuenUnsDirHelfenZuKönnen",
    "HowToHinzufügen",
    "VideoGenerieren",
    "Suche",
    "Kommunikation",
    "Teamverwaltung",
    "analytics",
    "conversations",
    "Insights",
    "interviews",
    "performance",
    "Reporting",
    "Rahmenbedingungen",
    "Intervall",
    "ZeitraumWählen",
    "Täglich",
    "Zeitraum",
    "Monatlich",
    "Quartalsweise",
    "Jährlich",
    "required",
    "von",
    "bis",
    "Start",
    "Ende",
    "Heute",
    "StelleAuswählen",
    "Reset",
    "Suchen",
    "KommunikationsmediumWählen",
    "PhaseDesGesprächs",
    "Weiterverarbeitung",
    "Anrufe",
    "EMails",
    "SMS",
    "WhatsApp",
    "Interviews",
    "Einstufungstests",
    "Lebensläufe",
    "Profile",
    "Analysen",
    "NullErgebnisse",
    "Ergebnisse",
    "ExportExcel",
    "POWERBI",
    "ReportingTabelle",
    "ExportBewerberInterviews",
    "Stellenanzeige",
    "Datum",
    "Uhrzeit",
    "Dauer",
    "Antworten",
    "Lebenslauf",
    "Terminlink",
    "Browser",
    "ReportingGraph",
    "AuswertungDerBewerberdaten",
    "ExportToPDF",
    "InterviewStreetDataAnalysis",
    "ConversionGraph",
    "AuswertungDerConversionRate",
    "IndeedEMailIntegration",
    "DieEMailIntegrationErmöglichtEsIhnenDieBewerberVonIndeedMitCVParsingFunktionInMONAEinlesenZuLassen",
    "FürEineIntegrationKontaktierenSiesupportmonaaideUndWirMeldenUnsInKürze",
    "Indeed",
    "Talent360EMailIntegration",
    "Talent360",
    "ZvooveRecruit",
    "Aktivieren",
    "ZvooveBewerberAPIKey",
    "ZvooveBewerberAPILink",
    "ZvooveStellenAPIKey",
    "ZvooveStellenAPILink",
    "MONALoginUsername",
    "MONALoginPasswort",
    "KIMatching",
    "exklusiv",
    "inklusiv",
    "inklusivMitFallback",
    "Zvoove",
    "Aktiviert",
    "nichtAktiv",
    "Talention",
    "TalentionClientID",
    "TalentionClientSecret",
    "TalentionAccountID",
    "TalentionIntegrationsweg",
    "talentionCreateApplicantJobId",
    "Alle",
    "GebieteNL",
    "Jobs",
    "TalentionGebieteNiederlassungen",
    "BeispielBerlinHamburgMünchen",
    "KeywordsMitKommaTrennen",
    "CompleetAPIPersoprofilerCompana",
    "GEPEXAPI",
    "CompleetAPIKeys",
    "StandortAbteilung",
    "Compleet",
    "initiativRow",
    "IndexAnzeigendaten",
    "IndexLogin",
    "Passwort",
    "StellenanzeigeLöschen",
    "SindSieSicherDassSieDieseStellenanzeigeLöschenMöchten",
    "zurück",
    "backToJobOffersHeader",
    "fontStyleLabel",
    "backToJobOffersMessage",
    "IframeKopieren",
    "addJobButtonText",
    "Kopieren",
    "StellenangebotBearbeiten",
    "Stellentitel",
    "Produktionshelfer",
    "Einleitung",
    "BeschreibenSieKurzUndKnappIhrUnternehmen",
    "Aufgaben",
    "BeschreibenSieDieGenauenAufgabenUndVerantwortungsbereicheDerStelleDamitDerBewerberVerstehtWasDiesePositionAttraktivMacht",
    "Qualifikation",
    "BeschreibenSieIhreAnforderungenAnDenKandidaten",
    "Benefits",
    "NennenSieBenefitsWelcheIhrUnternehmenEinzigartigUndAttraktivMachen",
    "Schlussworte",
    "WirFreuenUnsÜberDeineBewertung",
    "GehaltBrutto",
    "Land",
    "Stadt",
    "Deutschland",
    "Frankreich",
    "VereinigtesKönigreich",
    "Schweiz",
    "Österreich",
    "Belgien",
    "Niederlande",
    "Luxemburg",
    "Spanien",
    "Italien",
    "Polen",
    "Dänemark",
    "Schweden",
    "Norwegen",
    "Finnland",
    "Estland",
    "Lettland",
    "Litauen",
    "Tschechien",
    "Slowakei",
    "Ungarn",
    "Slowenien",
    "Kroatien",
    "Serbien",
    "Ukraine",
    "Russland",
    "Suchen",
    "StadtSuchen",
    "Vertrag",
    "UploadLogo",
    "KlickenZumÄndern",
    "FarbauswahlKopfzeile",
    "FarbauswahlKörper",
    "FarbauswahlFürDenFirmentitel",
    "AvatarKonfigurieren",
    "AvatarName",
    "MONA",
    "AvatarAuswählen",
    "Automatisierung",
    "FragenAnDenBewerber",
    "Parameter",
    "Feld",
    "Fragetyp",
    "abfragen",
    "übersetztIn",
    "ParameternameExistiertBereits",
    "NachrichtExistiertBereits",
    "HelpNoMessageAnswersPresent",
    "NoCommunicationWorkflowsPresent",
    "SetCommunicationWorkflowHasBeenDeleted",
    "HelpCommunicationWorkflowHasBeenDeletedExclamationOtherWorkflowExists",
    "HelpChooseAnotherQuestionTypeAsNoCommunicationWorkflow",
    "InvalidMessage",
    "CodingChallenge",
    "vorgeschlageneFragen",
    "ErweiterteEinstellungen",
    "automatischeBewerbung",
    "VertragOderDokumenteErklären",
    "Sprachsteuerung",
    "CVParsingZuBeginnDesGesprächs",
    "automatischerEinstellungstest",
    "BrowserspracheErzwingen",
    "Feedback",
    "SprachenAuswählen",
    "deutsch",
    "französisch",
    "bulgarisch",
    "englisch",
    "ukrainisch",
    "türkisch",
    "rumänisch",
    "polnisch",
    "slowakisch",
    "arabisch",
    "ungarisch",
    "tschechisch",
    "portugiesisch",
    "italienisch",
    "holländisch",
    "spanisch",
    "russisch",
    "dänisch",
    "schwedisch",
    "chinesisch",
    "kroatisch",
    "serbisch",
    "albanisch",
    "kasachisch",
    "indonesisch",
    "litauisch",
    "estnisch",
    "afrikaans",
    "hindi",
    "malayalam",
    "Flowchart",
    "ConditionalRoutings",
    "FlowchartZurücksetzen",
    "FlowchartZurücksetzenText",
    "CreateANewNodeButton",
    "CreateNewNode",
    "ToastForStandaloneNodes",
    "ToastStandaloneNodeAdded",
    "ToastHeaderForStandaloneNodes",
    "FullscreenFlowchart",
    "ExportToExcel",
    "EinstellungstestAnAlleSenden",
    "keineBewerberText",
    "Herkunft",
    "Bewerbernummer",
    "Stelle",
    "Email",
    "Telefon",
    "SpaltenAnpassen",
    "Bewerbungseingang",
    "QALab",
    "NeuLaden",
    "Aktiv",
    "Draft",
    "Test",
    "Gelöscht",
    "ImportierenVonStellenanzeigen",
    "ExportierenVonStellenanzeigen",
    "Reaktivieren",
    "Verträge",
    "KeineStellenangeboteGefunden",
    "Aktualisiert",
    "Stellenangebot",
    "Standort",
    "URL",
    "Iframe",
    "IFrameKopieren",
    "StatusDerBereitstellung",
    "SpeichernAlsTemplate",
    "StellenangebotErstellen",
    "VorgeschlageneFragen",
    "Aktualisieren",
    "UmVorgeschlageneFragenZugenerierenGebenSieBitteHierDenStellentitelEin",
    "StellenanzeigeBearbeiten",
    "GenerierenSieFragen",
    "Hinzufügen",
    "AILabTrainingPanel",
    "Keyword",
    "Anzahl",
    "Keywords",
    "deutsch",
    "ChangeCompanyLogoJPGPNG",
    "BildHinzufügen",
    "BitteGebenSieEinKleineresBildEin",
    "Entfernen",
    "AlteNachricht",
    "NeueNachricht",
    "neueNachrichtEingeben",
    "Recruiting",
    "Onboarding",
    "Vertrieb",
    "Ziel",
    "Dokumente",
    "BewerberId",
    "Kontakt",
    "EmailPreview",
    "ViewEmail",
    "UpdateLOG",
    "TageHer",
    "Plattform",
    "Verbesserung",
    "BugFix",
    "Herunterladen",
    "AnswerVideo",
    "Image",
    "abgeschlossenesStudium",
    "mehrAls6MonateBerufserfahrung",
    "Deutschkenntnisse",
    "Übernehmen",
    "FehlerBeimLadenDerDatei",
    "AccountEinstellungen",
    "UnternehmensInformationen",
    "WebseitenLink",
    "Farbauswahl",
    "FarbeAuswählen",
    "SpracheAuswählen",
    "Kontaktierung",
    "Standorte",
    "Straße",
    "Hausnr",
    "PLZ",
    "Ort",
    "EMinusMail",
    "calendlyLink",
    "Datenschutz",
    "GebenSieHierIhrenDatenschutzLinkEin",
    "BitteGebenSieEineGültigeURLEin",
    "MatchingProfilvertrieb",
    "FallbackFürInterviews",
    "FallbackFürFinishedInterviewDocument",
    "MatchingExtern",
    "MinimumMatchingErgebnis",
    "MatchingKriterium",
    "MatchingTyp",
    "MatchingGewicht",
    "Optionen",
    "EUWorker",
    "Hard",
    "Soft",
    "WennDerMatchingTyp",
    "ausgewähltIstDannMussDasKriteriumErfülltWerdenDamitEinMatchVorliegt",
    "ausgewähltIstDannMussDasKriteriumNichtErfülltWerdenDamitEinMatchVorliegt",
    "EineGewichtungVon1IstDieNiedrigsteGewichtungFürEinMatchingkriterium",
    "EineGewichtungVon200IstDieNiedrigsteGewichtungFürEinMatchingkriterium",
    "insgesamtKönnen20KriterienAngepasstWerdenGematchedWerdenInsgesamt25KriterienUndDieInterviewergebnisse",
    "BewerberprofilKonfigurieren",
    "ProfilbildAutomatischErgänzen",
    "SprachenMüssenEnthaltenSein",
    "BerufserfahrungMussEnthaltenSein",
    "Zertifikate",
    "Softskills",
    "ProjektkenntnisseMüssenEnthaltenSein",
    "AufenthaltserlaubnisArbeitserlaubnisMussVorliegenOderAbgefragtSein",
    "BewerberprofilKonfigurieren",
    "BewerberAnlegen",
    "BewerberSchnellerfassung",
    "Strasse",
    "Hausnummer",
    "Wohnort",
    "TelefonMobil",
    "Geburtsdatum",
    "ChoosePDFFile",
    "AngabenZurPerson",
    "Geschlecht",
    "Adresse",
    "Geburtsland",
    "Geburtsort",
    "Staatsangehörigkeit",
    "Sprachen",
    "BestätigungscodeSMS",
    "EmailBestätigt",
    "KFZ",
    "Führerschein",
    "EMailVonMONAGesendet",
    "SMSVonMONAGesendet",
    "TelefonanrufVonMONAGesendet",
    "Ausbildung",
    "Monate",
    "Abschluss",
    "höchsterAbschluss",
    "Hauptschulabschluss",
    "MittlereReife",
    "OhneAbschluss",
    "Abitur",
    "höchsteAusbildung",
    "ohneAusbildung",
    "Berufsausbildung",
    "mitAbschluss",
    "Bachelor",
    "Promotion",
    "Diplom",
    "Meister",
    "Bemerkungen",
    "Qualifikationen",
    "Vorschläge",
    "Match",
    "Berufserfahrung",
    "Sprachtest",
    "GrammatikUndSatzbau",
    "Wortschatz",
    "KohärenzUndKlarheit",
    "Anmerkungen",
    "Talent360Info",
    "Einsatzort",
    "Kandidat",
    "BewerberLog",
    "MonaLog",
    "noData",
    "erfolg",
    "fehler",
    "dateDesc",
    "dateAsc",
    "typeDesc",
    "typeAsc",
    "TranskriptionDesVideos",
    "VideoAntwort",
    "TranskriptionDesAudios",
    "EigeneFelder",
    "EinstellungstestErgebnisse",
    "Punkte",
    "Aufgabe",
    "erreichtePunkte",
    "keineDatenVorhanden",
    "Schließen",
    "Archivieren",
    "Editieren",
    "Exportieren",
    "EinstellungstestSenden",
    "VertragErstellen",
    "SendeDokumentAnBewerber",
    "KomplettPDFAbrufen",
    "ProzessStarten",
    "Stufe2",
    "Stufe3",
    "Handy",
    "Anruf",
    "LogAlsPDFExportieren",
    "VideoAnsehen",
    "eigenesFeldErgänzen",
    "Dateien",
    "Dateiname",
    "EMailSchicken",
    "SMSSchicken",
    "anrufenLassen",
    "KundeWarSehrZufrieden",
    "abgeschlosseneBerufsausbildungAlsMechaniker",
    "Erfahrung",
    "zehnJahreErfahrung",
    "Unternehmen",
    "FieldName",
    "FieldValue",
    "Remove",
    "FeldErgänzen",
    "Submit",
    "DateiHierherZiehen",
    "ArchivierteAusblenden",
    "ArchivierteAnzeigen",
    "AlleZeigen",
    "nichtAlleZeigen",
    "Schnellerfassung",
    "BewerberInDenLetzten30Tagen",
    "LadeAlle",
    "exportExcel",
    "exportToExcelAlle",
    "ReportingErstellen",
    "erstellen",
    "Export",
    "DatenImport",
    "DataWarehouse",
    "Integrationen",
    "Blacklist",
    "BewerberLeadgenerierung",
    "KundenLeadgenerierung",
    "KIStudio",
    "SucheNachNameOderAktionOderMedium",
    "ZeitProBewerber",
    "inMin",
    "StundenlohnDisponentEuro",
    "OpenDocument",
    "NoDocumentAvailable",
    "Team",
    "TeammitgliederVerwalten",
    "BewerberExcelImport",
    "IndexStellenanzeigen",
    "TalentionUpload",
    "IndexUpload",
    "BewerberUpload",
    "ExcelStandardVorlageDownloaden",
    "BewerberKontaktieren",
    "BewerberÜbernehmen",
    "BewerberImportListe",
    "Bewerberin",
    "Mobilnummer",
    "TalentionDatenHochladen",
    "wurdenAusgelesenUndAnalysiertMitKI",
    "IndexAnzeigendatenJSONUpload",
    "PERSONALIZE_MESSAGE",
    "GENERATEQAQUESTIONS_LOADING_MESSAGE",
    "GENERATEQA_PROMPT_MESSAGE",
    "JOB_TITLE_NOTSET_MESSAGE",
    "REFRASEQANDAQUESTIONS_TEXTBLOCK",
    "AIALERT_MESSAGE",
    "AIFEEDBACKONPREQUISITES_MESSAGE",
    "VALIDATE_CANTLINKTOITSELF_MESSAGE",
    "VALIDATE_NOCONDITIONSBUTVALUEISSET_MESSAGE",
    "VALIDATE_CONDITIONPRESENTBUTVALUEISNOTSET_MESSAGE",
    "VALIDATE_NOCONDITIONS_ONSTARTNODE_MESSAGE",
    "VALIDATE_NEWUPDATEDLINK_CONTAINSVALUEBUTCONDITIONJAORNEIN_MESSAGE",
    "MAXIMUM_QUESTIONS_REACHED_MESSAGE",
    "VALIDATECYCLE_WITHOUTCONDITIONS_MESSAGE",
    "ERROR_CLOUDFUNCTION_MESSAGE",
    "GENERATE_ASSESSMENT_ANSWERS",
    "GENERATE_ASSESSMENT_QUESTIONS_ANSWERS_ONLY_TITLE",
    "PREVIEW_NOT_AVAILABLE_HEADER",
    "PREVIEW_NOT_AVAILABLE_MESSAGE",
    "DATA_PROTECTION_URL_INVALID_MESSAGE",
    "DATA_PROTECTION_URL_NOTE_MESSAGE",
    "JOB_OFFER_RESTORED",
    "NO_JOB_OFFER_RECORDS_TEXT",
    "NO_APPLICANT_RECORDS_TEXT",
    "APPLICANT_DELETED_SUCCESSFULLY",
    "LOADING_TEXT_DASHBOARD",
    "STELLENANZEIGE_ERSTELLEN",
    "IFRAME_KOPIEREN",
    "EMAIL_TEXT",
    "SMS_TEXT",
    "BETREFF_TEXT",
    "STATUS_INPRÜFUNG",
    "STATUS_INTERVIEW_ABGESCHLOSSEN",
    "STATUS_BEGINNT_BEWERBUNGSPROZESS",
    "STATUS_EINGESTELLT",
    "STATUS_VERMITTELT",
    "STATUS_ABSAGE_DURCH_DISPONENT",
    "STATUS_ABSAGE_DURCH_KUNDE",
    "STATUS_ABSAGE_DURCH_BEWERBER",
    "STATUS_EINLADUNG_ZUM_VG",
    "STATUS_NOCHMAL_ANRUFEN",
    "STATUS_PROBEARBEIT",
    "STATUS_PROFIL_AN_KUNDEN",
    "STATUS_RÜCKRUF_FÜR_VEREINBARUNG",
    "STATUS_VC_INTERVIEW_NICHT_WAHRGENOMMEN",
    "STATUS_VC_INTERVIEW_VEREINBART",
    "STATUS_VG_DURCHGEFÜHRT",
    "STATUS_VG_NICHT_ERSCHIENEN",
    "STATUS_BEFINDET_SICH_AKTUELL_IM_INTERVIEW",
    'STATUS_EINSTELLUNGSTEST_ABGESCHLOSSEN',
    "SPECIFY_NODES",
    "INVALID_FLOWCHART",
    "SPECIFY_END_NODES",
    "IS_DANKE_MESSAGE_SAVED",
    "IS_SPRACHE_MESSAGE_SAVED",
    "IS_CVUpload_MESSAGE_SAVED",
    "STELLENANZEIGE_ERSTELLEN_MESSAGE",
    "ADD_END_SESSION_NODE_MESSAGE",
    "DELETE_MESSAGE",
    "NEED_TO_ADD_END_SESSION",
    "ERROR_WHEN_OPEN_APPLICANT",
    "UPDATE_JOB_ADVERTISEMENT",
    "PUBLISH",
    "CALENDLY_BETREFF_TEXT",
    "CALENDLY_TEXT",
    "ProfilErstellt",
    "selectLocation",
    "LimitReached",
    "LimitReachedMessage",
    "Vorname",
    "Nachname",
    "E-Mail",
    "Handynummer",
    "Abschicken",
    "DELETE_FLOWCHART",
    "EXISTIERT_BEREITS",
    "KNOTEN_HINZUFUGEN",
    "VERBINDUNG_AKTUALISIEREN",
    "DateiHochladen",
    "HINWEIS",
    "HINWEIS_MESSAGE",
    "SAVE_AS_DRAFT",
    "SAVE_IN_TEST_MODE",
    "ASK_QUESTIONS_PROMT",
    "JOB_AD_TEXT",
    "Abschicken",
    "MessageStillInFlowchart",
    "InfoMessageForMessagePresentInFlowhchart",
    "INVALID_ANSWER_IN_FLOWCHART_LINK",
    "MESSAGE_MULTIPLE_LINKS_FROM_ONE_NODE_WITH_SAME_CONDITION_IS_NOT_ALLOWED",
    "INVALID_ANSWER_IN_FLOWCHART_LINK_MESSAGE",
    "keineAktion",
    "MESSAGE_AFTER_EDIT_QUESTION_TYPE",
    "CANT_DELETE_LAST_LINK",
    "FLOWCHART_START_NODE_MULTIPLE_EDGES",
    "CLICK_TO_SEE_IMAGE",
    "OneWeek",
    "DateRange",
    "keineReportingText",
    "Hochladen",
    "IndexAnzeigendatenJSONUploadError",
    "DateiErfolgreichHochgeladen",
    "DateiErfolgreichHochgeladenMessage",
    "AnzahlDatensätze",
    "BewerberValide",
    "BewerberMitDokumenten",
    "BewerberMitInterview",
    "BewerberMitTerminoption",
    "BewerberMitProfilErstellt",
    "BewerberMitProfilVersandt",
    "BewerberMitProfilInteresse",
    "BewerberMitMatchings",
    "ErstkontaktInsights",
    "ZweitkontaktInsights",
    "DrittkontaktInsights",
    "geschätztesPotentialProfilvertrieb",
    "geschätzteErfolgsquoteVermittlung",
    "geschätzteErfolgsquoteAUEV",
    "SearchInAllColumns",
    "AnalysiereAnzeigenMitAI",
    "AnalysiereKandidatenMitAI",
    "StartMatchesWithAI",
    "BlacklistAbgleichen",
    "Matches",
    "Beschäftigungsgruppe",
    "Quote",
    "MatchingEinstellungen",
    "FragenSuchen",
    "StandardFragen",
    "EigeneFragen",
    "ausgewählte",
    "AusgewählteFragenSpeichern",
    "keineMatchesText",
    "EmailAutomatisierungfuerBewerber",
    "Modelauswaehlen",
    "Vorlage",
    "Testmail",
    "TestmailAnSchicken",
    "BewerberDaten",
    "BewerberDatenAbrufen",
    "BewerberImport",
    "BewerberDatenHochladen",
    "VideosGenerierenFuer",
    "AlleEmailsSchicken",
    "SelectAndConnectEndpoints",
    "SelectSourceEndpoint",
    "SelectDestinationEndpoint",
    "ConnectEndpoints",
    "AlleIntegrationen",
    "SaaS",
    "OnPremise",
    "API",
    "Ordner",
    "ExklusivePartnervonMONAAI",
    "AllApps",
    "Bewerberdaten",
    "Verlassen",
    "ready",
    "inDevelopment",
    "inTesting",
    "generateApiKey",
    "sendSMS",
    "sendMail",
    "sendCall",
    "sendWhatsApp",
    "sendLinkedIn",
    "sendXing",
    "sendFacebook",
    "sendInstagram",
    "sendX",
    "confirm",
    "EditAndSend",
    "Bewerberanzahl",
    "Valide",
    "BewerberMitDokumenten",
    "InterviewGestartet",
    "InteviewBeendet",
    "BewerberMitTerminoption",
    "BewerberMitProfil",
    "JobtitelUnbekannt",
    "Dokumentation",
    "FreigegebeneTelefonnummern",
    "Landauswählen",
    "VollständigeNummer",
    "FreigegebeneEMailAdressen",
    "Sprachpräferenzen",
    "Bestätigen",
    "Agent",
    "Prompt",
    "BewerberprofilFürDirektvertrieb",
    "Company",
    "Location",
    "Position",
    "URLLink",
    "CompanyLink",
    "CompanyReport",
    "CompanyPhone",
    "ContactPerson",
    "ContactPersonEmail",
    "ContactPersonPhone",
    "Goal",
    "AcquisitionSubject",
    "MatchingPunktzahl",
    "Erklaerung",
    "Reflexion",
    "Unternehmensdetails",
    "bewerberContingent",
    "DuBistEingeloggtMit",
    "id",
    "VertriebHistorie",
    "WorkflowsAnwenden",
    "RunAgentTask",
    "SalesmailsLöschen",
    "SalesmailsFreigeben",
    "UnternehmenGefunden",
    "durchgeführteMatches",
    "positiveMatches",
    "Matches50",
    "negativeMatches",
    "Dubletten",
    "IndexUnternehmensanalyse",
    "Unternehmenswebsite",
    "GoogleMaps",
    "KeineUnternehmenGefunden",
    "SucheNachUnternehmen",
    "LINK_UPDATE_WITH_INVALID_ANSWER",
    "MESSAGE_MULTIPLE_LINKS_WITH_SAME_VALUE_AND_SAME_CONDITION",
    "CVUPLOAD_FLOWCHART_NODE_EXISTS_TOAST",
    "duplicateWorkflowText",
    "ExternalAccess",
    "ExternalAccessSettings",
    "ExternalAccessSettingsMessage",
    "ReadApplicants",
    "PushApplicants",
    "ReadJobOffers",
    "PushJobOffers",
    "ReadAgents",
    "PushAgents",
    "ReadData",
    "PushData",
    "GenerateAPIKey",
    "YourNewAPIKey",
    "PleaseCopyThisKeyMessage",
    "EmailAutomation",
    "AgentConfig",
    "AgentConfigEmailHeader",
    "AgentConfigEmailHeaderDesc",
    "AgentConfigEmailHeaderPlaceholder",
    "AgentConfigEmailFooter",
    "AgentConfigEmailFooterDesc",
    "AgentConfigEmailFooterPlaceholder",
    "AgentConfigSaved",
    "AgentConfigSaveFailed",
    "AgentConfigHeaderSaved",
    "AgentConfigHeaderSaveFailed",
    "AgentConfigInsertTable",
    "AgentConfigInsertLink",
    "AgentConfigInsertLinkPrompt",
    "AgentConfigInsertLinkLabel",
    "EmailAutomationSettings",
    "EmailAutomationSettingsMessage",
    "SaveEmailConfigurationManually",
    "GenerateNewEmailAddress",
    "DeleteEmailAccount",
    "IMAPEmailAddress",
    "SMTPEmailAddress",
    "ExternalAccessAndAPI",
    "APIAndConnections",
    "AboAndSubscription",
    "UserId",
    "SelectUser",
    "SelectRole",
    "Recruiter",
    "Admin",
    "ManageBillingSettingsHere",
    "ManageBilling",
    "MatchingTypeForMonaJobs",
    "MatchingArtMONA",
    "YourNewEmailAddress",
    "SelectWorkflow",
    "SavePermissions",
    "SaveAutomation",
    "AIAssistant",
    "PleaseCopyThisPasswordMessage",
    "AIAssistantMessage",
    "Bewerberstatus",
    "Bewerberquelle",
    "Job_Bezeichnung",
    "Verfügbarkeit",
    "Gehalt",
    "Arbeitszeit",
    "Arbeitsvertrag",
    "Branchenkenntnisse",
    "projectExperience",
    "Persönlichkeit",
    "Arbeitsrechtliche_Einschränkungen",
    "Management Level",
    "Mobilität",
    "DeleteEmailAccountMessage",
    "Kriteriumauswaehlen",
    "password",
    "EmailAccountDeleted",
    "EmailAccountSaved",
    "SearchForApps",
    "StandortAuswählen",
    "Erfolgreichgespeichert",
    "ErfolgreichgespeichertText",
    "FehlertextfürdieEinstellung",
    "OrdnerHinzufügen",
    "SuchenachAgenten",
    "NeuenOrdernerHinzufügen",
    "Ordnername",
    "AgentHinzufügen",
    "NeuenAgentenHinzufügen",
    "Agentenname",
    "deleteFolder",
    "deleteFolderText",
    "deleteAgent",
    "deleteAgentText",
    "Aktionen",
    "Zugriffskontrolle",
    "Benachrichtigungen",
    "Compliance",
    "Leistungsüberwachung",
    "Agentbearbeiten",
    "Ausführen",
    "AgentennamenEingeben",
    "Ausführungsrhythmus",
    "WähleRhythmus",
    "Manuell",
    "Wöchentlich",
    "CustomInterval",
    "ZeitfürtäglicheAusführung",
    "WochentagefürAusführung",
    "WähleWochentage",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
    "Sonntag",
    "ZeitfürwöchentlicheAusführung",
    "Intervallbeispiel",
    "IntervallinStunden",
    "Aufgabehinzufügen",
    "Aufgabentitel",
    "Aufgabename",
    "Textaufforderung",
    "AngehängtesDokument",
    "agentUpdateSuccessText",
    "agentUpdateErrorText",
    "agentLoadErrorText",
    "agenterstellen",
    "agentSavedSuccessfully",
    "agentSaveError",
    "folderNameRequired",
    "emailBlacklist",
    "BlacklistanzeigenKunden",
    "Blacklisthochladen",
    "BlacklistLength",
    "emailAdress",
    "AddBlacklistMember",
    "uploadlimit",
    "uploadInstruction",
    "Clear",
    "Neuhochgeladen",
    "noDataFound",
    "noNewEntriesFound",
    "uploadTooManyEntries",
    "searchPlaceholder",
    "notInBlacklistYet",
    "RecruitingApi",
    "AgentApi",
    "Kalendar",
    "Mitarbeiterdaten",
    "Aufträge",
    "allData",
    "Active",
    "TerminÜberURLBuchen",
    "DealValue",
    "TerminÜberURLBuchenBeschreibung",
    "InValidURL",
    "EditEmail",
    "ViewEmailContent",
    "AttachNewAttachment",
    "ShowLead",
    "ShowCompanyDetails",
    "ShowMoreJobs",
    "Cancel",
    "discardChanges",
    "wirdNichtGespeichert",
    "discard",
    "searchRequirement",
    "searchMinimumChars",
    "searching",
    "searchError",
    "uploading",
    "uploadSuccess",
    "newEmailsAdded",
    "duplicatesSkipped",
    "invalidEmail",
    "checking",
    "emailExists",
    "emailAlreadyInBlacklist",
    "adding",
    "emailAddedSuccessfully",
    "errorAddingEmail",
    "enterEmail",
    "addToBlacklist",
    "addEmailInfo",
    "searchButtonNotice",
    "maxShown",
    "bulkUploadGuide",
    "overview",
    "bulkUploadOverview",
    "uploadMethods",
    "method1FileUpload",
    "supportedFormats",
    "excelFormat",
    "excelFormatDesc",
    "steps",
    "fileUploadSteps",
    "method2ManualEntry",
    "manualEntryDesc",
    "format",
    "oneEmailPerLine",
    "importantRules",
    "rule1",
    "rule2",
    "rule3",
    "rule4",
    "rule5",
    "exampleFormat",
    "chooseUploadMethod",
    "fileUpload",
    "supportedFiles",
    "manualEntry",
    "manualEntryPlaceholder",
    "REACTIVATING_JOB_OFFER_CONTAINS_DELETED_WORKFLOW",
    "InterviewContainsDeletedCommunicationWorkflowMessage",
    "Versanddatum",
    "SetValueOfDeal",
    "Neu",
    "BitteWählenSieEinZeitraum",
    "InterviewDropoutAnalysis",

    // Workspace translations
    "WorkspaceTitle",
    "WhatsOnYourMind",
    "NewIdeas",
    "CheckingQuestions",
    "AIEmployees",

    // Agent names
    "AgentFields",
    "AgentVine",
    "AgentBuzz",
    "AgentCedar",
    "AgentFinn",
    "AgentOliver",
    "AgentBloom",
    "AgentMarket",
    "AgentSparkle",
    "AgentFeast",
    "AgentSugar",
    "AgentSwift",
    "AgentGreen",
    "AgentEco",
    "AgentSpark",
    "AgentFlow",
    "AgentMason",
    "AgentArtie",
    "AgentRidge",
    "AgentBrick",
    "AgentTile",
    "AgentCool",
    "AgentCycle",
    "AgentCraft",
    "AgentStitch",
    "AgentGem",
    "AgentDough",
    "AgentGourmet",
    "AgentForge",
    "AgentClay",
    "AgentWeave",
    "AgentGuard",

    // Agent roles
    "RoleFarmer",
    "RoleVineyardOwner",
    "RoleBeekeeper",
    "RoleForester",
    "RoleFishFarmer",
    "RoleOrganicFarmer",
    "RoleHorticulturist",
    "RoleMarketTrader",
    "RoleCleaningServiceProvider",
    "RoleCaterer",
    "RolePastryChef",
    "RoleCourierServiceOperator",
    "RoleLandscapingServiceOwner",
    "RoleWasteManagementContractor",
    "RoleElectrician",
    "RolePlumber",
    "RoleCarpenter",
    "RolePainterAndDecorator",
    "RoleRoofer",
    "RoleBricklayer",
    "RoleTiler",
    "RoleHVACTechnician",
    "RoleBicycleRepairTechnician",
    "RoleFurnitureMaker",
    "RoleTailor",
    "RoleJeweler",
    "RoleBaker",
    "RoleSpecialtyFoodProducer",
    "RoleMetalworker",
    "RoleCeramicist",
    "RoleTextileManufacturer",
    "RoleSecurityServicesContractor",
    "Tutorialsuchen",
    "Einführung",
    "Schnittstellen",
    "Prozesse",
    "Agenten",
    "Assistenten",
    "Ressourcen",
    "Einladen",
    "TerminÜberURLBuchen",
    "TerminÜberURLBuchenBeschreibung",
    "InValidURL",
    "REACTIVATING_JOB_OFFER_CONTAINS_DELETED_WORKFLOW",
    "InterviewContainsDeletedCommunicationWorkflowMessage",
    "BeingTranslated",
    "FileWithNoWorkflows",
    "AutoSaveData",
    "ReloadAutoSaveData",
    "MessageExist",
    "MessageExistInfo",
    "MessageNotExist",
    "MessageNotExistInfo",
    "CanNotConnect",
    "MustHaveCondition",
    "ConditionNotWithYesNoMessage",
    "ConditionNotWithSingleMultiMessage",
    "ConditionWithValue",
    "DoesNotExistInMessage",
    "ConditionWithYesNoMessage",
    "ConditionWithSingleMultiMessage",
    "ConditionNotWithStart",
    "SourceOfConditionNotExist",
    "ConditionOneMessage",
    "doesNotExist",
    "HasAnotherSource",
    "HasAlreadyCondition",
    "HasConnectWithCurrentCondition",
    "CanNotConnectYesNoCondition",
    "NotYesNoMessage",
    "NotSingleMultiMessage",
    "ConditionWithOtherTarget",
    "ActionWithOtherTarget",
    "StartNotAsTarget",
    "EndNotAsSource",
    "NotLoop",
    "MessageWithOtherTarget",
    "ConditionNotWithCondition",
    "ActionConditiontarget",
    "ActionNotWithAction",
    "ConditionBetweenMessageCondition",
    "ActionBetweenMessageCondition",
    "ActionBetweenMessageAction",
    "ActionBetweenConditionCondition",
    "ActionBetweenConditionAction",
    "ConditionNotWithAction",
    "StandaloneNotUsed",
    "StandaloneNotUsedSaveDelete",
    "AnswerOptionsNotUsed",
    "AnswerOptionsNotUsedInfo",
    "AnswerOptionsNotUsedContinue",
    "SwitchToFlowchart",
    "SwitchToFlowchartInfo",
    "MessageNoConnection",
    "ConnectAllMessage",
    "MessageConditionActionError",
    "MessageConditionActionErrorInfo",
    "LineError",
    "LineErrorInfo",
    "FlowchartEmpty",
    "FlowchartEmptyInfo",
    "SelectMode",
    "DragMode",
    "UndoMessage",
    "RedoMessage",
    "UndoFlowchart",
    "RedoFlowchart",
    "ZoomOut",
    "ZoomIn",
    "RemoveFlowchart",
    "AddNewFlowchart",
    "CreateANewNode",
    "FullScreenMode",
    "DuplicateFlowchart",
    "ResetFlowchart",
    "SameSourceTarget",
    "ConditionActionOrderWrong",
    "ConditionSameValue",
    "RemoveFailedMessage",
    "BothMessageSame",
    "applicantReactivatedSuccessfully",
    "applicantArchivedSuccessfully",
    "CoreDataAccess",
    "AgentManagement",
    "ToolManagement",
    "MatchingAnalytics",
    "DocumentProcessing",
    "Communication",
    "Administrative",
    "ExecuteAgents",
    "ExecuteWorkflow",
    "ReadTools",
    "ManageTools",
    "ReadMatching",
    "CreateMatching",
    "ReadAnalytics",
    "Parsing",
    "ReadCommunication",
    "ManageApiKeys",
    "SystemAdmin",
    "GenerateApiKey",
    "reload",
    "MitInterview",
    "Einzelkontaktierung",
    "EinzellkontaktierungInfo",
    "systemStatus",
    "Notes",
    "DealValue",
    "WorkflowCustom",
    "WorkflowCustomDescription",
    "WorkflowEmailDirekt",
    "WorkflowEmailNach4h",
    "WorkflowEmailNach24h",
    "WorkflowEmailNach48h",
    "WorkflowSMSDirekt",
    "WorkflowSMSNach4h",
    "WorkflowSMSNach24h",
    "WorkflowSMSNach48h",
    "WorkflowAnrufDirekt",
    "WorkflowAnruf4h",
    "WorkflowAnruf24h",
    "WorkflowAnruf48h",
    "WorkflowTerminbuchungMitSMSUndEmail",
    "WorkflowTerminbuchungDirektImInterview",
    "WorkflowEmailAnDisponentNachInterviewEnde",
    "WorkflowEmailAnBewerberNachInterviewEnde",
    "WorkflowProfilerstellung",
    "WorkflowPrematchingGegenIndex",
    "WorkflowBewerberprofilDirektvertrieb",
    "WorkflowCustom",

    "WorkflowEmailDirektDescription",
    "WorkflowEmailReminderDescription",
    "WorkflowSMSDirektDescription",
    "WorkflowSMSReminderDescription",
    "WorkflowAnrufDirektDescription",
    "WorkflowAnrufReminderDescription",
    "WorkflowTerminbuchungMitSMSUndEmailDescription",
    "WorkflowTerminbuchungDirektImInterviewDescription",
    "WorkflowEmailAnDisponentNachInterviewEndeDescription",
    "WorkflowEmailAnBewerberNachInterviewEndeDescription",
    "WorkflowProfilerstellungDescription",
    "WorkflowPrematchingGegenIndexDescription",
    "WorkflowBewerberprofilDirektvertriebDescription",
    "WorkflowCustomDescription",
    "DokumentNameFestelegen",

    "WorkflowEmailSubjectNachBewerbungseingang",
    "WorkflowTerminbuchungBetreff",
    "WorkflowTerminbuchungEmailText",
    "WorkflowTerminbuchungSMSText",
    "WorkflowInterviewFinishedEmailSubject",
    "WorkflowThanksToApplicantEmailSubject",
    "WorkflowBewerberprofilEmailSubject",
    "WorkflowBewerberMitMatchesEmailSubject",

    "WorkflowDocumentNameBewerberprofil",
    "WorkflowDocumentNamePrematching",
    "Kalender",
    "QRCode",
    "RichEmailEditorVorname",
    "RichEmailEditorNachname",
    "RichEmailEditorFirmenname",
    "RichEmailEditorInterviewURL",
    "RichEmailEditorCalendly",
    "RichEmailEditorExportHTML",
    "RichEmailEditorSave",
    "RichEmailEditorBold",
    "RichEmailEditorItalic",
    "RichEmailEditorUnderline",
    "RichEmailEditorInsertImage",
    "RichEmailEditorInsertFirstName",
    "RichEmailEditorInsertLastName",
    "RichEmailEditorInsertCompanyName",
    "RichEmailEditorInsertInteractionButton",
    "RichEmailEditorInsertCalendlyButton",
    "RichEmailEditorExportToHTML",
    "RichEmailEditorUploadingImage",
    "RichEmailEditorPlaceholder",
    "RichEmailEditorImageUploadError",
    "RichEmailEditorInteractionLinkClicked",
    "RichEmailEditorCalendlyLinkClicked",
    "RichEmailEditorClickHere",
    "RichEmailEditorScheduleMeeting",
    "RichEmailEditorStartInterview",
    "RichEmailEditorTable",
    "RichEmailEditorInsertTable",
    "RichEmailEditorInsertTableCustom",
    "RichEmailEditorInsertTableColumns",
    "RichEmailEditorInsertTableRows",
    "RichEmailEditorIncrease",
    "RichEmailEditorDecrease",
    "RichEmailEditorInsertTablePrompt",
    "RichEmailEditorInsertTableInvalid",
    "RichEmailEditorFontColor",
    "RichEmailEditorHighlightColor",
    "RichEmailEditorNoColor",
    "RichEmailEditorOtherColors",
    "RichEmailEditorCustomColor",
    "RichEmailEditorAlign",
    "RichEmailEditorAlignLeft",
    "RichEmailEditorAlignCenter",
    "RichEmailEditorAlignRight",
    "RichEmailEditorAlignJustify",
    "RichEmailEditorLineSpacing",
    "RichEmailEditorInsertLink",
    "RichEmailEditorLinkUrl",
    "RichEmailEditorLinkUrlPlaceholder",
    "RichEmailEditorLinkUrlInvalid",
    "RichEmailEditorRemoveLink",
    "RichEmailEditorRemoveLinkPrompt",
    "RichEmailEditorTableBorderColor",
    "RichEmailEditorTableBorderWidth",
    "RichEmailEditorTableCellBackground",
    "RichEmailEditorTableCellAlign",
    "RichEmailEditorTableCellVerticalAlign",
    "RichEmailEditorTableAlignTop",
    "RichEmailEditorTableAlignMiddle",
    "RichEmailEditorTableAlignBottom",
    "RichEmailEditorTableCellAlignTopLeft",
    "RichEmailEditorTableCellAlignTopCenter",
    "RichEmailEditorTableCellAlignTopRight",
    "RichEmailEditorTableCellAlignMiddleLeft",
    "RichEmailEditorTableCellAlignMiddleCenter",
    "RichEmailEditorTableCellAlignMiddleRight",
    "RichEmailEditorTableCellAlignBottomLeft",
    "RichEmailEditorTableCellAlignBottomCenter",
    "RichEmailEditorTableCellAlignBottomRight",
    "RichEmailEditorTableInsert",
    "RichEmailEditorTableDelete",
    "RichEmailEditorTableInsertAbove",
    "RichEmailEditorTableInsertBelow",
    "RichEmailEditorTableInsertLeft",
    "RichEmailEditorTableInsertRight",
    "RichEmailEditorTableDeleteRows",
    "RichEmailEditorTableDeleteColumns",
    "RichEmailEditorTableMergeCells",
    "RichEmailEditorTableSplitCells",
    "RichEmailEditorShape",
    "RichEmailEditorShapeRectangle",
    "RichEmailEditorShapeRoundedRectangle",
    "RichEmailEditorShapeCircle",
    "RichEmailEditorShapeTriangle",
    "RichEmailEditorShapeDiamond",
    "RichEmailEditorShapeArrow",
    "RichEmailEditorShapeFillColor",
    "RichEmailEditorShapeBorderColor",
    "RichEmailEditorShapeBorderWidth",
    "RichEmailEditorShapeBorderRadius",
    "RichEmailEditorShapeDelete",
    "RichEmailEditorShapeWidth",
    "RichEmailEditorShapeHeight",
    "RichEmailEditorShapeRotation",
    "RichEmailEditorImageCopy",
    "RichEmailEditorImageDelete",
    "EditApplicantMessage",
    "AccountOverview",
    "CurrentPlan",
    "Available",
    "Billing",
    "PricingPlans",
    "ExploreOurFlexiblePricingOptionsAndUpgradeYourPlan",
    "ViewPricing",
    "SubscriptionExpiredTitle",
    "SubscriptionExpiredMessage",
    "GoToPricing",
    "BitteWarten",
    "NeuesInterview",
    "WählenSieEineOptionZumErstellenIhresInterviews",
    "BlankJobOffer",
    "VorlagenJobOffer",
    "LeeresInterview",
    "ErstellenSieEinNeuesInterviewVonGrundAuf",
    "VollständigeAnpassung",
    "EigeneInhalte",
    "FlexibleGestaltung",
    "LeeresInterviewErstellen",
    "VorlagenDurchsuchen",
    "NachVorlagenSuchen",
    "VorlageJobOffer",
    "InterviewVorlage",
    "VorgefertigtesInterviewSchnelleErstellung",
    "AvatarJobOffer",
    "WeiblichJobOffer",
    "MännlichJobOffer",
    "TerminJobOffer",
    "AnspracheJobOffer",
    "DuJobOffer",
    "SieJobOffer",
    "VerwendenJobOffer",
    "KeineVorlagenGefunden",
    "VersuechenSieEinenAnderenSuchbegriff",
    "FehlerBeimErstellenDesInterviews",
    "InterviewWurdeErfolgreichErstellt",
    "BitteGebenSieEinenPromptEin",
    "KeineVorlagenVerfügbar",
    "BitteWählenSieEineVorlageAus",
    "VideoLimitReached",
    "AIInterviewAktivierenTitel",
    "AIInterviewAktivierenText",
    "AIInterviewKonfigurierenTitel",
    "AIInterviewKonfigurierenText1",
    "AIInterviewKonfigurierenText2",
    "InterviewCheckpoints",
    "AIInterviewCheckpointsDesc",
    "ExploreCulturalFit",
    "ExploreCulturalFitDesc",
    "ExploreTechnicalFit",
    "ExploreTechnicalFitDesc",
    "TextOnly",
    "TextOnlyDesc",
    "AIPersonality",
    "AIPersonalityDesc",
    "AIPersonalityPlaceholder",
    "AIInterviewGoalsDesc",
    "ZielHinzufuegen",
    "OhneAIInterviewFortfahren",
    "EinstellungenUebernehmen",
    "Ziele",
    "DangerZone",
    "DangerZoneDescription",
    "PleaseWaitForEmailGeneration",
    "EmailGenerationTimeout",
    "EmailAccountGeneratedSuccessfully",
    "ApplicantMaxCountReached",
    "WorkflowExecuted",
    "ApplicantsDuplicatedAndContacted",

    // Applicant Inbox Modal translations
    "YourApplicantInboxAddress",
    "GenerateYourDedicatedApplicantInbox",
    "WelcomeToMONAAI",
    "GenerateYourDedicatedApplicantInboxAddress",
    "GenerateApplicantInboxEmail",
    "Generating",
    "GenerationStarted",
    "TheEmailAddressWillBeSaved",
    "YourApplicantInbox",
    "UseThisAddressToReceiveApplications",
    "Copy",
    "GeneratingInboxEmail",
    "ApplicantInboxEmailGeneratedSuccessfully",
    "TimedOutWaitingForInboxEmail",
    "FailedToStartGeneration",
    "EmailCopiedToClipboard",
    "DialCode",
    "CVUpload",
    "TheseItems",
    "DeleteApplicants",
    "EnterDelete",
    "TextIsNotCorrect",
    "WhatWouldYouLikeToDoWith",
    "Archive",
    "MoveToArchive",
    "DeletePermanently",
    "FinalWarningToDelete",
    "AreYouSureYouWantToDelete",
    "ThisActionCannotBeUndone",
    "OhneStandort",
    "Chat",
    "Agents",
    "Agent Builder",
    "Data Pipeline",
    "Profil",
    "Searches",
    "Shortlist",
    "Contacts",
    "Sequences",
    "Analytics",
    "Integrations",
    "SidebarTodaysTasks",
    "SidebarNoTasks",
    "SidebarUpcomingInterviews",
    "SidebarNoInterviews",
    "SidebarConnectCalendar",
    "TaskCatInterviewApplicant",
    "TaskCatScheduleApplicant",
    "TaskCatAskMissingInfo",
    "TaskCatSendProfile",
    "TaskCatWriteJobOffer",
    "TaskCatReviewApplications",
    "TaskCatSendRejection",
    "TaskCatFollowUpCandidate",
    "TaskCatFollowUpClient",
    "TaskCatCheckReferences",
    "TaskCatPrepareContract",
    "TaskCatUpdatePipeline",
    "TaskCatSourceCandidates",
    "TaskCatOnboardNewHire",
    "TaskCatHiring",
    "TaskCatFollowUp",
    "TaskCatAdmin",
    "TaskCatOutreach",
    "ChooseWorkflowTemplate",
    "SearchTemplates",
    "UseTemplate",
    "NoTemplatesFound",
    "AdjustSearchOrFilter",
    "WfCatHR",
    "WfCatData",
    "WfCatSupport",
    "Organigramm",
    "LocationsTeams",
    "NoOrgStructure",
    "SwitchToWorkflows",
    "ChooseAction",
    "ActionCommunication",
    "ActionSendEmail",
    "ActionSendSMS",
    "ActionAIAssistant",
    "ActionReviewResume",
    "ActionScoreCandidate",
    "ActionScheduling",
    "ActionScheduleInterview",
    "ActionSendCalendarLink",
    "ActionDataManagement",
    "ActionUpdateStatus",
    "ActionAddNote",
    "WfAiPlaceholder",
    "WfAiPlaceholderShort",
    "WfAiIntro",
    "WfAiSugAutoReply",
    "WfAiSugParseCv",
    "WfAiSugDailyReport",
    "WfAiSugOnboarding",
    "WfAiSugReactivation",
    "WfAiSugGdpr",
    "WfAiSugContracts",
    "WfAiErrorRetry",
    "WfAiWorkflowDiscarded",
    "WfAiReadyToSave",
    "WfAiSaveWorkflow",
    "WfAiDiscard",
    "WfAiModify",
    "WfAiSaved",
    "WfAiClose",
    "WfAiCreateAnother",
    "WfAiSaveError",
    "AllAgents",
    "Role",
    "NoDescription",
    "NoWorkflowsLinked",
    "NoIntegrationsConnected",
    "NoActivityRecorded",
    "EditAgentViaPrompt",
    "AgentEditPlaceholder",
    "AddIntegration",
    "OrgAiPlaceholder",
    "Activity",
    "AdKiTools",
    "AdToolsSubtitle",
    "AdToolEmail",
    "AdToolEmailSend",
    "AdToolDb",
    "AdToolDbFind",
    "AdToolDbUseCv",
    "AdToolIndex",
    "AdToolIndexSearch",
    "AdToolIndexReq",
    "AdToolUrlParser",
    "AdToolUrlParserDesc",
    "AdToolCvParser",
    "AdToolCvParserDesc",
    "AdToolCall",
    "AdToolCallStart",
    "AdToolSms",
    "AdToolSmsShort",
    "AdToolReminder",
    "AdToolReminderDesc",
    "AdPremiumFeature",
    "AdCompanySmtp",
    "AdCompanyMissing",
    "AdSearchAgents",
    "AdSelectAgent",
    "AdSelectOrSwitch",
    "AdChatHistory",
    "AdHistory",
    "AdNewChat",
    "AdClose",
    "AdHistoryLoading",
    "AdMessages",
    "AdNoHistory",
    "AdNoHistoryDesc",
    "AdStartNewChat",
    "AdDropFiles",
    "AdDropFilesDesc",
    "AdUploadFiles",
    "AdUploadFilesDesc",
    "AdInternetToggle",
    "AdInternetDesc",
    "AdInternet",
    "AdThinkingToggle",
    "AdThinkingDesc",
    "AdThinking",
    "AdShowTools",
    "AdTools",
    "AdSkills",
    "AdSendMessage",
    "AdAgentPreparing",
    "AdFirstMsgHint",
    "AdPlaceholder",
    "AdGdpr",
    "AdGdprDetails",
    "AdDisclaimer",
    "AdSmsSuccess",
    "AdRecipient",
    "AdMessage",
    "AdServerResponse",
    "AdSaveToMemory",
    "AdDataPipeline",
    "AdCandidatesFound",
    "AdContactInfo",
    "AdExperience",
    "AdCallSuccess",
    "AdLivestreamToggle",
    "AdSkillsSubtitle",
    "AdAnalysisSkills",
    "AdFilterSkills",
    "AdLoadingSkills",
    "AdError",
    "AdUnknownError",
    "AdSendError",
    "AdNewConversation",
    "AdConversation",
    "AdBrowserAutomation",
    "AdBrowserTask",
    "AdBrowserTaskPlaceholder",
    "AdBrowserUrl",
    "AdBrowserUrlPlaceholder",
    "AdBrowserCredentials",
    "AdBrowserUseCredentials",
    "AdBrowserEmail",
    "AdBrowserPassword",
    "AdBrowserAdvanced",
    "AdBrowserMaxSteps",
    "AdBrowserOutputFormat",
    "AdBrowserScreenshots",
    "AdBrowserDebug",
    "AdBrowserExtraction",
    "AdBrowserExtractData",
    "AdBrowserFieldName",
    "AdBrowserSelector",
    "AdBrowserAddRule",
    "AdBrowserTemplates",
    "AdBrowserLinkedIn",
    "AdBrowserSalesforce",
    "AdBrowserScraping",
    "AdBrowserForm",
    "AdBrowserCode",
    "AdCopy",
    "AdCancel",
    "AdInsertInChat",
    "AdExecute",
    "AdLivestreamAvailable",
    "AdOpenLivestream",
    "AdBrowserRunning",
    "AdBrowserStillRunning",
    "AdFilesGenerated",
    "AdDocFailed",
    "AdPreview",
    "AdDownload",
    "AdDocSuccess",
    "AdAgentPreparingTitle",
    "AdAgentPreparingMsg",
    "AdPremiumTitle",
    "AdPremiumMsg",
    "AdUpgrade",
    "AdDbSetup",
    "AdDbSetupMsg",
    "AdUseCvParser",
    "AdGoIntegrations",
    "AdIndexSetup",
    "AdIndexSetupMsg",
    "AdGoProfile",
    "AdEmailSetup",
    "AdEmailSetupMsg",
    "AdSmsSetup",
    "AdSmsSetupMsg",
    "AdCallSetup",
    "AdCallSetupMsg",
    "AdCopied",
    "AdCodeCopied",
    "AdCopyError",
    "AdFileOpenError",
    "AdFileDownloadError",
    "AdCodeCopy",
    "AdConfirm",
    "AdLegalPhone",
    "AdLegalSms",
    "AdLegalEmail",
    "AdLegalConfirmMsg",
    "AdBackToChat",
    "AdScheduledRuns",
    "AdDeactivate",
    "AdActivate",
    "AdDelete",
    "AdRequiredData",
    "AdExampleQuestions",
    "AdUploadFilesOptional",
    "AdDropFilesOrClick",
    "AdDataSource",
    "AdNoPipeline",
    "AdUrlDownload",
    "AdEmailReport",
    "AdEmailPlaceholder",
    "AdDescribeTask",
    "AdStartAnalysis",
    "AdSetupSchedule",
    "AdAutoRun",
    "AdTime",
    "AdDays",
    "AdDaily",
    "AdWeekdays",
    "AdMoWeFr",
    "AdTuTh",
    "AdMonday",
    "AdTuesday",
    "AdWednesday",
    "AdThursday",
    "AdFriday",
    "AdSaturday",
    "AdSunday",
    "AdReportEmail",
    "AdReportPlaceholder",
    "AdSaveSchedule",
    "AdRuntime",
    "AdAnalysisComplete",
    "AdDiscussWithAgent",
    "AdNewAnalysis",
    "AdRetry",
    "AdExamples",
    "AdClear",
    "AdDataNeeded",
    "AdDataSourceHint",
    "AdApiCredentials",
    "AdEmailReportDone",
    "AdDocErrorMessage",
    "AdMemory",
    "AdFeedback",
    "AdResearch",
    "AdDeepResearchMode",
    "AdDeepResearchHint",
    "AdDeepResearchExit",
    "AdResearchPlaceholder",
    "AdSkillsTooltip",
    "AdResearchTooltip",
    "AdResearchReport",
    "AdOpenInNewTab",
    "AdPrintPdf",
    "AdTargetWebsite",
    "AdRunning",
    "GoToChat",
    "Connected",
    "NotConnected",
    "ConnectedAccount",
    "ConnectedSince",
    "Tip",
    "HowItWorks",
    "AdvancedSettings",
    "ForAdvancedUsers",
    "AdvancedWarning",
    "FirstName",
    "LastName",
    "FullName",
    "PositionTitle",
    "Location",
    "Company",
    "TranscriptsLoading",
    "DragFileOrClick",
    "AiAnalyzing",
    "FileReading",
    "Analyzing",
    "AnalyzeWithAi",
    "Append",
    "Replace",
    "DropFilesHere",
    "SupportedFormats",
    "CurrentAgentKnowledge",
    "LiWelcomeTitle",
    "LiWelcomeDesc",
    "LiConnected",
    "LiWaiting",
    "LiConnect",
    "LiStartOutreach",
    "LiAccount",
    "LiConnectHint",
    "LiActiveReady",
    "LiCheckConnection",
    "LiSwitchAccount",
    "LiTipSingleAccount",
    "LiStep1Title",
    "LiStep1Desc",
    "LiStep2Title",
    "LiStep2Desc",
    "LiStep3Title",
    "LiStep3Desc",
    "LiStep4Title",
    "LiStep4Desc",
    "LiTipRateLimit",
    "LiMessageTemplates",
    "LiConnectionRequest",
    "LiDirectMessage",
    "LiAiPersonalization",
    "LiAiPersonalizationDesc",
    "LiAiActive",
    "LiAiActiveDesc",
    "LiPlaceholdersTip",
    "LiCharLimit",
    "VcWelcomeTitle",
    "VcWelcomeDesc",
    "VcConnectPhone",
    "VcStartCalls",
    "VcPhoneNumber",
    "VcNumber",
    "VcVerifyPhone",
    "VcAddNumber",
    "VcPhoneTip",
    "VcStep1Title",
    "VcStep1Desc",
    "VcStep2Title",
    "VcStep2Desc",
    "VcStep3Title",
    "VcStep3Desc",
    "VcStep4Title",
    "VcStep4Desc",
    "VcCreditTip",
    "VcSystemPromptDesc",
    "VcCustomInstrDesc",
    "ApiKeyDuration",
    "Days",
    "Unlimited",
    "Warning",
    "UnlimitedApiKeyWarning",
    "Confirm",
    "AllPermissionsEnabledByDefault",
    "CurrentCredits",
    "CVFilterCurrentCredits",
    "CVFilterBuyCredits",
    "DeepInterviewCredits",
    "AdditionalCredits",
    "PurchaseMoreCredits",
    "RunningOutOfCredits",
    "CreditsPayPerUseNote",
    "AutoRecharge",
    "AutoRechargeSettings",
    "AutoRechargeDescription",
    "EnableAutoRecharge",
    "RechargeWhenBelow",
    "RechargeAmount",
    "AutoRechargeNote",
    "SettingsSaved",
    "ErrorSavingSettings",
    "AutoRechargeError",
    "ApiKeysDescription",
    "CVFilter",
    "CVFilterConfigure",
    "CVFilterDescription",
    "CurrentAPIKeys",
    "CustomizePermissions",
    "MaxApiKeysReached",
    "MobileNummer",
    "NeuesPasswortGenerieren",
    "Sales",
    "AllgemeineEinstellungen",
    "StandortnameExistiertBereits",
    "validatePhoneNumber",
    "VerantwortlichePerson",
    "TelefonAndCode",
    "NichtKonfiguriert",
    "KontaktierungNachrichten",
    "Konfiguriert",
    "MatchingErgebnisseZusenden",
    "liveHilfeBeantragen",
    "liveHilfeNachricht",
    "callBuchen",
    "emailSenden",
    "abbrechen",
    "logout",

    // mona-communication-list translations
    "LadeMatchesImHintergrund",
    "LadeVertriebshistorieImHintergrund",
    "ProzentAbgeschlossen",
    "MatchesGeladen",
    "WeitereMatchesLaden",
    "Lade",
    "MatchingAusgewaehlt",
    "KeineDatenVorhanden",
    "WeitereKontakteLaden",
    "Ladet",
    "KorrespondenzenGeladen",
    "WeitereLaden",
    "Weitere",
    "PDFOeffnen",
    "EmailAnzeigen",
    "Dokument",
    "Kriterien",
    "JobOffer",
    "EmailEditor",
    "SwitchToNormalMode",
    "SwitchToHTMLMode",
    "EmailVorschau",
    "UploadAttachment",
    "Uploading",
    "UploadBtn",
    "MatchingHeader",

    // mona-agent-builder.page
    "AgentBuilderEditAgent",
    "AgentBuilderCreateNewAgent",
    "AgentBuilderSelectAgent",
    "AgentBuilderUpdateAgent",
    "AgentBuilderCreateMyAgent",
    "AgentBuilderStep1Title",
    "AgentBuilderStep1Short",
    "AgentBuilderStep2Title",
    "AgentBuilderStep2Short",
    "AgentBuilderStep3Title",
    "AgentBuilderStep3Short",
    "AgentBuilderStep4Title",
    "AgentBuilderStep4Short",
    "AgentBuilderStep5Title",
    "AgentBuilderMONAIntroTitle",
    "AgentBuilderMONAIntroBullet1",
    "AgentBuilderMONAIntroBullet2",
    "AgentBuilderMONAIntroBullet3",
    "AgentBuilderMONAResultTitle",
    "AgentBuilderMONARecommendedTools",
    "AgentBuilderMONAGeneratedInstructions",
    "AgentBuilderMONAResultHint",
    "AgentBuilderMONAITitle",
    "AgentBuilderMONAQuestionWord",
    "AgentBuilderMONAOfTotal",
    "AgentBuilderMONAPreviousAnswers",
    "AgentBuilderMONAAnswerPrefix",
    "AgentBuilderMONATextareaPlaceholder",
    "AgentBuilderMONASkipInterview",
    "AgentBuilderMONANextQuestion",
    "AgentBuilderMONAGenerateAgent",
    "AgentBuilderAgentNameLabel",
    "AgentBuilderAgentNameHint",
    "AgentBuilderDuplicateName",
    "AgentBuilderAgentIconLabel",
    "AgentBuilderAgentIconHint",
    "AgentBuilderChangeIcon",
    "AgentBuilderChooseAgentIcon",
    "AgentBuilderUploadOwnImage",
    "AgentBuilderUploadImage",
    "AgentBuilderSupportedFormats",
    "AgentBuilderYourUploadedImages",
    "AgentBuilderCustomBadge",
    "AgentBuilderStandardIcons",
    "AgentBuilderAgentTypeLabel",
    "AgentBuilderAgentTypeHint",
    "AgentBuilderCustomAgentTitle",
    "AgentBuilderCustomAgentSubtitle",
    "AgentBuilderCustomAgentFeat1",
    "AgentBuilderCustomAgentFeat2",
    "AgentBuilderCustomAgentFeat3",
    "AgentBuilderMonariAgentTitle",
    "AgentBuilderMonariAgentSubtitle",
    "AgentBuilderMonariFeat1",
    "AgentBuilderMonariFeat2",
    "AgentBuilderMonariFeat3",
    "AgentBuilderExpertiseLabel",
    "AgentBuilderExpertiseHint",
    "AgentBuilderExpertisePlaceholder",
    "AgentBuilderGreetingLabel",
    "AgentBuilderGreetingHint",
    "AgentBuilderGreetingPlaceholder",
    "AgentBuilderToolsLabel",
    "AgentBuilderToolsHint",
    "AgentBuilderToolsAutoMONA",
    "AgentBuilderSelectAllTools",
    "AgentBuilderDeselectAllTools",
    "AgentBuilderToolLockedShort",
    "AgentBuilderToolLockedLong",
    "AgentBuilderMONASelectedBadge",
    "AgentBuilderInstructionsLabel",
    "AgentBuilderInstructionsHint",
    "AgentBuilderMinCharsBanner",
    "AgentBuilderInstructionItem",
    "AgentBuilderInstructionsAddedSuffix",
    "AgentBuilderInstructionSidebarTitle",
    "AgentBuilderInstructionEnter",
    "AgentBuilderInstructionPlaceholder",
    "AgentBuilderInstructionDuplicate",
    "AgentBuilderAccessTypeLabel",
    "AgentBuilderAccessTypeHint",
    "AgentBuilderPublicTitle",
    "AgentBuilderPublicDesc",
    "AgentBuilderRestrictedTitle",
    "AgentBuilderRestrictedDesc",
    "AgentBuilderApprovalTitle",
    "AgentBuilderApprovalDesc",
    "AgentBuilderCreatorLabel",
    "AgentBuilderAuthorizedUsersLabel",
    "AgentBuilderAuthorizedUsersHint",
    "AgentBuilderPermEditDesc",
    "AgentBuilderPermReadDesc",
    "AgentBuilderPermChatDesc",
    "AgentBuilderEmailPlaceholder",
    "AgentBuilderPermissionPlaceholder",
    "AgentBuilderPermEdit",
    "AgentBuilderPermRead",
    "AgentBuilderPermChat",
    "AgentBuilderSummaryTitle",
    "AgentBuilderSummaryType",
    "AgentBuilderSummaryTools",
    "AgentBuilderSelectedCountSuffix",
    "AgentBuilderSummaryExpertise",
    "AgentBuilderExpertiseAreasSuffix",
    "AgentBuilderSummaryInstructions",
    "AgentBuilderSummaryInstructionsAddedSuffix",
    "AgentBuilderSummaryAccess",
    "AgentBuilderSummaryApprovalSuffix",
    "AgentBuilderExportTemplate",
    "AgentBuilderMyAgents",
    "AgentBuilderActive",
    "AgentBuilderInactive",
    "AgentBuilderTypeCustom",
    "AgentBuilderTypeMonari",
    "AgentBuilderMONAFloatToggle",
    "AgentBuilderMONAFloatOn",
    "AgentBuilderMONAFloatOff",
    "AgentBuilderMONAConfiguredToast",
    "MONAInterviewQuestion1",
    "MONAInterviewQuestion2",
    "MONAInterviewQuestion3",
    "AgentBuilderLoading",
    "AgentBuilderToastToolLocked",
    "AgentBuilderToastAllToolsSelected",
    "AgentBuilderToastAllToolsCleared",
    "AgentBuilderToastAgentNotLoaded",
    "AgentBuilderToastLoadedForEdit",
    "AgentBuilderToastLoadError",
    "AgentBuilderToastFileLimit",
    "AgentBuilderToastFilesQueued",
    "AgentBuilderToastFileRemoved",
    "AgentBuilderToastFileRemoveError",
    "AgentBuilderToastInvalidImage",
    "AgentBuilderToastImageTooLarge",
    "AgentBuilderToastImageUploadOk",
    "AgentBuilderToastUploadFailedGeneric",
    "AgentBuilderToastUploadUnauthorized",
    "AgentBuilderToastUploadCanceled",
    "AgentBuilderToastUploadUnknown",
    "AgentBuilderToastUploadFirebaseError",
    "AgentBuilderToastToolsLoadFailed",
    "AgentBuilderToastNotLoggedIn",
    "AgentBuilderToastDbFailed",
    "AgentBuilderToastValidName",
    "AgentBuilderToastPickTool",
    "AgentBuilderToastAddInstruction",
    "AgentBuilderToastEmptyInstruction",
    "AgentBuilderToastDuplicateInstruction",
    "AgentBuilderToastMinChars",
    "AgentBuilderCreatingAgentLoading",
    "AgentBuilderAccountSetupLoading",
    "AgentBuilderToastAddExpertise",
    "AgentBuilderToastGreetingRequired",
    "AgentBuilderToastUpdateSuccess",
    "AgentBuilderToastCreateSuccess",
    "AgentBuilderToastAnswerRequired",
    "AgentBuilderToastExportNameRequired",
    "AgentBuilderToastExportSuccess",
    "AgentBuilderErrorNotLoggedIn",
    "AgentBuilderErrorStorageInit",
    "AgentBuilderErrorStorageRef",
    "AgentBuilderErrorUploadTaskRetry",
    "AgentBuilderErrorUploadTaskFailed",
    "AgentBuilderErrorCreateGeneric",
    "AgentBuilderErrorApiKey",
    "AgentBuilderErrorNetwork",
    "AgentBuilderErrorSystem",
    "AgentBuilderErrorUnknown",
    "AgentBuilderPermLegendEdit",
    "AgentBuilderPermLegendRead",
    "AgentBuilderPermLegendChat",
    "AgentBuilderUsersAuthorizedSuffix",
    "AgentBuilderUserCountShort",

    // mona-agent-chat.page
    "AgentChatActive",
    "AgentChatAgentCreating",
    "AgentChatStepPrepareTemplate",
    "AgentChatStepCreateConfig",
    "AgentChatStepActivateAI",
    "AgentChatStepSave",
    "AgentChatStepFinalize",
    "AgentChatHelloIAm",
    "AgentChatHowCanIHelp",
    "AgentChatAgentsTitle",
    "AgentChatNoCount",
    "AgentChatAgentsOnline",
    "AgentChatSearchPlaceholder",
    "AgentChatFilterAll",
    "AgentChatFilterExperts",
    "AgentChatFilterSystem",
    "AgentChatFilterYourAgents",
    "AgentChatPinnedAgents",
    "AgentChatPinnedDesc",
    "AgentChatUnpinAgent",
    "AgentChatPinAgent",
    "AgentChatCardProfile",
    "AgentChatCardExperience",
    "AgentChatCardSpecialist",
    "AgentChatCardKnowledge",
    "AgentChatCardMore",
    "AgentChatCardIntegration",
    "AgentChatCardRequires",
    "AgentChatPublic",
    "AgentChatRestricted",
    "AgentChatApprovalRequired",
    "AgentChatUsersAuthorized",
    "AgentChatEmailsAuthorized",
    "AgentChatCreatedBy",
    "AgentChatExpertsTitle",
    "AgentChatExpertsDesc",
    "AgentChatSystemTitle",
    "AgentChatSystemDesc",
    "AgentChatYourAgentsTitle",
    "AgentChatYourAgentsDesc",
    "AgentChatOwnAgent",
    "AgentChatPersonalAgentDesc",
    "AgentChatPersonalized",
    "AgentChatNoAgentsYet",
    "AgentChatCreateFirstDesc",
    "AgentChatCreateFirstAgent",
    "AgentChatNoResults",
    "AgentChatNoResultsPrefix",
    "AgentChatNoResultsSuffix",
    "AgentChatResetSearch",
    "AgentChatAddAgent",
    "AgentChatDragHint",
    "AgentChatMessageTo",
    "AgentChatDescribeTask",
    "AgentChatBrowserPlaceholder",
    "AgentChatURLOptional",
    "AgentChatURLPlaceholder",
    "AgentChatLivestreamAvailable",
    "AgentChatOpenLivestream",
    "AgentChatCancel",
    "AgentChatExecute",
    "AgentChatCandidatesFound",
    "AgentChatShowDetails",
    "AgentChatExportList",
    "AgentChatRefineSearch",
    "AgentChatContactFound",
    "AgentChatWorkExperience",
    "AgentChatSendEmail",
    "AgentChatViewCV",
    "AgentChatSaveContact",
    "AgentChatSmsSuccess",
    "AgentChatRecipient",
    "AgentChatMessageLabel",
    "AgentChatServerResponse",
    "AgentChatSaveToMemory",
    "AgentChatDataPipeline",
    "AgentChatCallSuccess",
    "AgentChatFilesGenerated",
    "AgentChatDocFailed",
    "AgentChatPreview",
    "AgentChatDownload",
    "AgentChatDocError",
    "AgentChatToggleLivestream",
    "AgentChatToolRequired",
    "AgentChatToolNotActivated",
    "AgentChatActivating",
    "AgentChatActivateTool",
    "AgentChatAISpecialist",
    "AgentChatActivateTemplate",
    "AgentChatTemplateDesc",
    "AgentChatSkillsLabel",
    "AgentChatCreateAgentBtn",
    "AgentChatAddToConversation",
    "AgentChatSearchNameCategory",
    "AgentChatDeleteLabel",
    "AgentChatAlreadyAdded",
    "AgentChatClose",
    "AgentChatAITools",
    "AgentChatToolsSubtitle",
    "AgentChatToolEmail",
    "AgentChatToolEmailDesc",
    "AgentChatToolDatabase",
    "AgentChatToolDatabaseDesc",
    "AgentChatToolIndex",
    "AgentChatToolIndexDesc",
    "AgentChatToolUrlParser",
    "AgentChatToolUrlParserDesc",
    "AgentChatToolCVParser",
    "AgentChatToolCVParserDesc",
    "AgentChatToolCall",
    "AgentChatToolCallDesc",
    "AgentChatToolSmsDesc",
    "AgentChatToolReminder",
    "AgentChatToolReminderDesc",
    "AgentChatAgentSettings",
    "AgentChatUploading",
    "AgentChatFirstMessageBanner",
    "AgentChatAttachFile",
    "AgentChatVoiceInput",
    "AgentChatDisclaimer",
    "AgentChatManageKnowledge",
    "AgentChatAgentKnowledgeBase",
    "AgentChatKnowledgeBaseDesc",
    "AgentChatChooseFile",
    "AgentChatUploadProgress",
    "AgentChatFilesUploadedOf",
    "AgentChatSuccessLabel",
    "AgentChatErrorLabel",
    "AgentChatDone",
    "AgentChatSupportedFormats",
    "AgentChatPleaseWait",
    "AgentChatCVProcessing",
    "AgentChatSuccessHeader",
    "AgentChatAgentCreatedMsg",
    "AgentChatNoteHeader",
    "AgentChatAgentCreatedNote",
    "AgentChatErrorHeader",
    "AgentChatCVError",
    "AgentChatNewCandidate",
    "AgentChatCVGreeting",
    "AgentChatCVDescription",
    "AgentChatPremiumMsg",
    "AgentChatSetupDatabase",
    "AgentChatDatabaseEmpty",
    "AgentChatUseCVParser",
    "AgentChatGoToIntegrations",
    "AgentChatConfigureIndex",
    "AgentChatIndexSetupMsg",
    "AgentChatGoToProfile",
    "AgentChatConfigureEmail",
    "AgentChatConfigureSMS",
    "AgentChatConfigureCalls",
    "AgentChatEmailSetupFull",
    "AgentChatEmailSetupName",
    "AgentChatEmailSetupSmtp",
    "AgentChatSmsSetup",
    "AgentChatCallSetup",
    "AgentChatGoToProfileSettings",
    "AgentChatToolExecutedSuffix",
    "AgentChatAgentSelectionError",
    "AgentChatWelcomeHowCanIHelp",
    "AgentChatWelcomeWhatCanIDo",
    "AgentChatWelcomeHowCanIAssist",
    "AgentChatWelcomeGeneric",
    "AgentChatExpertGreetingFallback",
    "AgentChatUserAgentFallbackDesc",
    "AgentChatNoAgentsHeader",
    "AgentChatNoAgentsMsg",
    "AgentChatLater",
    "AgentChatSuggestionHelp",
    "AgentChatSuggestionSkills",
    "AgentChatSuggestionStart",
    "AgentChatSuggestionRecruitment",
    "AgentChatSuggestionJobPost",
    "AgentChatSuggestionOptimize",
    "AgentChatSuggestionExecSearch",
    "AgentChatSuggestionEvalLeader",
    "AgentChatSuggestionSuccession",
    "AgentChatCopied",
    "AgentChatMsgCopied",
    "AgentChatMsgCopyFailed",
    "AgentChatNoUserOrAgent",
    "AgentChatSaved",
    "AgentChatMsgSaved",
    "AgentChatMsgSaveFailed",
    "AgentChatMultiWelcome",
    "AgentChatMultiError",
    "AgentChatCodeCopy",
    "AgentChatCodeCopied",
    "AgentChatCodeCopyFailed",
    "AgentChatToolEnabled",
    "AgentChatToolEnableFailed",
    "AgentChatMaxTools",
    "AgentChatCandidateSearch",
    "AgentChatBrowserRunning",
    "AgentChatFileOpenError",
    "AgentChatFileDownloadError",
    "AgentChatKnowledgeCompany",
    "AgentChatKnowledgeAgent",
    "AgentChatKnowledgeChat",
    "AgentChatKnowledgeUnknown",
    "AgentChatNewChat",
    "AgentChatNoMessages",
    "AgentChatLastMessage",
    "AgentChatActivateIntegration",
    "AgentChatActivateNow",
    "AgentChatDetailsFailed",
    "AgentChatDbHasApplicants",
    "AgentChatDbNoApplicants",
    "AgentChatDbCheckError",
    "AgentChatInitializing",
    "AgentChatPrepareTemplateMsg",
    "AgentChatCreateConfigMsg",
    "AgentChatConfigureAIMsg",
    "AgentChatSaveToLibrary",
    "AgentChatAgentCreatedSuccess",
    "AgentChatGenerationError",
    "AgentChatFileUploadSuccess",
    "AgentChatFileDeleteSuccess",
    "AgentChatFileDeleteFailed",
    "AgentChatChooseKnowledgeType",
    "AgentChatWhereToSave",
    "AgentChatChatOnly",
    "AgentChatCompanyKnowledge",
    "AgentChatCompanyUploadSuccess",
    "AgentChatUploadErrorHeader",
    "AgentChatUploadFallbackMsg",
    "AgentChatInvalidFileType",
    "AgentChatInvalidFileMsg",
    "AgentChatDragDropSuccess",
    "AgentChatLimitReached",
    "AgentChatLimitReachedMsg",
    "AgentChatKnowledgeUpdated",
    "AgentChatKnowledgeUpdatedMsg",
    "AgentChatToolNameSms",
    "AgentChatToolNameEmail",
    "AgentChatToolNameCall",
    "AgentChatToolNameSearchDb",
    "AgentChatToolNameSearchIndex",
    "AgentChatToolNameReminder",
    "AgentChatToolNameCalendar",
    "AgentChatToolNameUrlParser",
    "AgentChatToolNameCvParser",
    "AgentChatToolNameDocGen",
    "AgentChatToolEmailReady",
    "AgentChatToolDbReady",
    "AgentChatToolIndexReady",
    "AgentChatToolSmsReady",
    "AgentChatToolCallReady",
    "AgentChatToolUrlParserReady",
    "AgentChatToolCVParserReady",
    "AgentChatToolReminderReady",
    "AgentChatToolCalendarReady",
    "AgentChatToolBrowserReady",
    "AgentChatToolDocGenReady",
    "AgentChatBusinessNameMissing",
    "AgentChatBusinessNameInProfile",
    "AgentChatFieldLocation",
    "AgentChatFieldEducation",
    "AgentChatFieldLanguages",
    "AgentChatSmsDetect",
    "AgentChatSmsFallback",
    "AgentChatMsgSent",
    "AgentChatCallDetect",
    "AgentChatCallFallback",
    "AgentChatCallDone",

    // agent-dashboard.page
    "AgentDashboardDropFilesTitle",
    "AgentDashboardDropFilesHint",
    "AgentDashboardChatHistory",
    "AgentDashboardHistory",
    "AgentDashboardHelloIAm",
    "AgentDashboardHowCanIHelp",
    "AgentDashboardMessageTo",
    "AgentDashboardAgentSelectorTitle",
    "AgentDashboardSelectAgent",
    "AgentDashboardUploadFiles",
    "AgentDashboardSelectMode",
    "AgentDashboardVoiceInput",
    "AgentDashboardExamples",
    "AgentDashboardBrowserTaskLabel",
    "AgentDashboardBrowserTaskPlaceholder",
    "AgentDashboardExampleUrl",
    "AgentDashboardLivestreamAvailable",
    "AgentDashboardOpenLivestream",
    "AgentDashboardCancel",
    "AgentDashboardExecute",
    "AgentDashboardFilesGenerated",
    "AgentDashboardDocCreationFailed",
    "AgentDashboardPreview",
    "AgentDashboardDownload",
    "AgentDashboardDocCreationNoFiles",
    "AgentDashboardLivestreamToggle",
    "AgentDashboardSmsSuccess",
    "AgentDashboardRecipient",
    "AgentDashboardMessageLabel",
    "AgentDashboardServerResponse",
    "AgentDashboardSaveToMemory",
    "AgentDashboardDataPipeline",
    "AgentDashboardCandidatesFound",
    "AgentDashboardContactInfoFound",
    "AgentDashboardWorkExperience",
    "AgentDashboardCallSuccess",
    "AgentDashboardGdprCompliant",
    "AgentDashboardGdprDetailsTitle",
    "AgentDashboardAiActCompliant",
    "AgentDashboardDisclaimer",
    "AgentDashboardBrowserTaskSection",
    "AgentDashboardBrowserTaskModalPlaceholder",
    "AgentDashboardBrowserTargetSite",
    "AgentDashboardBrowserUrlPlaceholder",
    "AgentDashboardBrowserCredentials",
    "AgentDashboardBrowserUseCredentials",
    "AgentDashboardBrowserEmailPlaceholder",
    "AgentDashboardBrowserPasswordPlaceholder",
    "AgentDashboardBrowserAdvancedSettings",
    "AgentDashboardBrowserMaxSteps",
    "AgentDashboardBrowserOutputFormat",
    "AgentDashboardBrowserScreenshots",
    "AgentDashboardBrowserDebugMode",
    "AgentDashboardBrowserExtraction",
    "AgentDashboardBrowserExtractSpecific",
    "AgentDashboardBrowserFieldName",
    "AgentDashboardBrowserSelectorPlaceholder",
    "AgentDashboardBrowserAddRule",
    "AgentDashboardBrowserTemplates",
    "AgentDashboardBrowserLinkedInSearch",
    "AgentDashboardBrowserDataScraping",
    "AgentDashboardBrowserFormFilling",
    "AgentDashboardBrowserGeneratedCode",
    "AgentDashboardBrowserCopy",
    "AgentDashboardBrowserInsertChat",
    "AgentDashboardUrlOptional",
    "AgentDashboardToolReqBusinessName",
    "AgentDashboardToolReqSmtp",
    "AgentDashboardEmailToolReady",
    "AgentDashboardEmailToolNotReady",
    "AgentDashboardDbReqUseCv",
    "AgentDashboardDbAccessError",
    "AgentDashboardDbToolReady",
    "AgentDashboardDbToolNotReady",
    "AgentDashboardToolReqEnableIndex",
    "AgentDashboardIndexToolReady",
    "AgentDashboardIndexToolNotReady",
    "AgentDashboardSmsToolNoBusinessName",
    "AgentDashboardSmsToolReady",
    "AgentDashboardSmsToolReqUpgrade",
    "AgentDashboardSmsToolReqBusinessName",
    "AgentDashboardCallToolReady",
    "AgentDashboardUrlParserReady",
    "AgentDashboardCvParserReady",
    "AgentDashboardReminderReady",
    "AgentDashboardCalendarReady",
    "AgentDashboardBrowserReady",
    "AgentDashboardDocGenReady",
    "AgentDashboardDefaultGreeting",
    "AgentDashboardGreetingFallback",
    "AgentDashboardSendMessageError",
    "AgentDashboardNewConversation",
    "AgentDashboardConversation",
    "AgentDashboardToolNameCall",
    "AgentDashboardToolNameDatabase",
    "AgentDashboardToolNameIndexSearch",
    "AgentDashboardToolNameReminder",
    "AgentDashboardToolNameCalendar",
    "AgentDashboardToolNameUrlParser",
    "AgentDashboardToolNameCvParser",
    "AgentDashboardToolNameDocGen",
    "AgentDashboardAgentInitHeader",
    "AgentDashboardAgentInitMsg",
    "AgentDashboardPremiumMsg",
    "AgentDashboardSetupDbHeader",
    "AgentDashboardSetupDbMsg",
    "AgentDashboardUseCvParser",
    "AgentDashboardGoToIntegrations",
    "AgentDashboardConfigIndexHeader",
    "AgentDashboardConfigIndexMsg",
    "AgentDashboardGoToProfile",
    "AgentDashboardConfigEmailHeader",
    "AgentDashboardConfigEmailMsgBoth",
    "AgentDashboardConfigEmailMsgName",
    "AgentDashboardConfigEmailMsgSmtp",
    "AgentDashboardConfigSmsHeader",
    "AgentDashboardConfigSmsMsg",
    "AgentDashboardConfigCallHeader",
    "AgentDashboardConfigCallMsg",
    "AgentDashboardGoToProfileSettings",
    "AgentDashboardBrowserRunning",
    "AgentDashboardBrowserStillRunning",
    "AgentDashboardBrowserStartFailed",
    "AgentDashboardCopiedHeader",
    "AgentDashboardCopiedMsg",
    "AgentDashboardCopyCodeTitle",
    "AgentDashboardCopyCodeFailed",
    "AgentDashboardErrorHeader",
    "AgentDashboardSuccessHeader",
    "AgentDashboardLegalNoticeCall",
    "AgentDashboardLegalNoticeHeader",
    "AgentDashboardLegalNoticeMsg",
    "AgentDashboardConfirm",
    "AgentDashboardFallbackTarget",
    "AgentDashboardContactLocation",
    "AgentDashboardContactEducation",
    "AgentDashboardContactLanguages",
    "AgentDashboardCandidateSearchTitle",
    "AgentDashboardSearchContextFull",
    "AgentDashboardSearchContextPosition",
    "AgentDashboardPromptCandidateDetails",
    "AgentDashboardPromptMultipleCandidates",
    "AgentDashboardCsvHeaderNote",
    "AgentDashboardExportFilename",
    "AgentDashboardPromptRefineSearch",
    "AgentDashboardFileOpenFailed",
    "AgentDashboardFileDownloadFailed",
    "AgentDashboardSettingsSaved",
    "AgentDashboardSettingsSaveFailed",
    "AgentDashboardAddExpertiseHeader",
    "AgentDashboardAddExpertisePlaceholder",
    "AgentDashboardAddButton",
    "AgentDashboardNoProjectConfigured",
    "AgentDashboardKnowledgeUploaded",
    "AgentDashboardKnowledgeUploadFailed",
    "AgentDashboardKnowledgeRemoved",
    "AgentDashboardKnowledgeRemoveFailed",
    "AgentDashboardDeleteAgentHeader",
    "AgentDashboardDeleteAgentMsg",
    "AgentDashboardDelete",
    "AgentDashboardBrowserAutomationPrefix",

    "DataPipelineTitle",
    "DataPipelineRefresh",
    "DataPipelineImport",
    "DataPipelineNewPipeline",
    "DataPipelineImportWorkflow",
    "DataPipelineUploadJson",
    "DataPipelineUploadJsonDesc",
    "DataPipelineChooseJsonFile",
    "DataPipelineImporting",
    "DataPipelineOr",
    "DataPipelineCreateFromMinJson",
    "DataPipelineCreateFromMinJsonDesc",
    "DataPipelineCreateBasic",
    "DataPipelineSupportedFormats",
    "DataPipelineFormatWorkflow",
    "DataPipelineFormatWebhook",
    "DataPipelineFormatDatabase",
    "DataPipelineFormatAiModel",
    "DataPipelineEditTitle",
    "DataPipelineCreateTitle",
    "DataPipelinePipelineName",
    "DataPipelineNamePlaceholder",
    "DataPipelineNameRequired",
    "DataPipelineDescription",
    "DataPipelineDescPlaceholder",
    "DataPipelineTargetAgent",
    "DataPipelineSelectAgent",
    "DataPipelineTargetAgentRequired",
    "DataPipelineLoadingAgents",
    "DataPipelineStatus",
    "DataPipelineInactive",
    "DataPipelineActive",
    "DataPipelineWebhookSettings",
    "DataPipelineRequireSignature",
    "DataPipelineSigningKey",
    "DataPipelineSigningKeyHelper",
    "DataPipelineWebhookUrl",
    "DataPipelineNotificationEmail",
    "DataPipelineNotificationEmailHelper",
    "DataPipelineExpiration",
    "DataPipelineExpirationHelper",
    "DataPipelineScheduleConfig",
    "DataPipelineScheduleType",
    "DataPipelineManualExecution",
    "DataPipelineIntervalBased",
    "DataPipelineCronExpression",
    "DataPipelineIntervalMinutes",
    "DataPipelineInvalidInterval",
    "DataPipelineIntervalHelper",
    "DataPipelineInvalidCron",
    "DataPipelineCronHelper",
    "DataPipelineTimezone",
    "DataPipelineDataSources",
    "DataPipelineDataSource",
    "DataPipelineDataSourceName",
    "DataPipelineDataSourceNamePlaceholder",
    "DataPipelineDataSourceNameRequired",
    "DataPipelineDataSourceType",
    "DataPipelineTypeHttp",
    "DataPipelineTypeWebhook",
    "DataPipelineTypeFile",
    "DataPipelineChooseFile",
    "DataPipelineSelectedFile",
    "DataPipelineFileUploadHelper",
    "DataPipelineConfigureHttp",
    "DataPipelineEndpoint",
    "DataPipelineMethod",
    "DataPipelineConfigureWebhook",
    "DataPipelineTestWebhook",
    "DataPipelineWebhookUrlLabel",
    "DataPipelinePrivateKey",
    "DataPipelinePrivateKeyHelper",
    "DataPipelineExamplePayload",
    "DataPipelineWebhookInfo",
    "DataPipelineAddDataSource",
    "DataPipelineSave",
    "DataPipelineCreatePipeline",
    "DataPipelineLoading",
    "DataPipelineNoData",
    "DataPipelineNoDataDesc",
    "DataPipelineCreateFirst",
    "DataPipelineNoDescription",
    "DataPipelineStatusLabel",
    "DataPipelineTargetAgentLabel",
    "DataPipelineDataSourcesLabel",
    "DataPipelineSources",
    "DataPipelineScheduleLabel",
    "DataPipelineLastRun",
    "DataPipelineLastRunStatus",
    "DataPipelineEditBtn",
    "DataPipelineExecuteBtn",
    "DataPipelineDeleteBtn",
    "DataPipelineConfirmDelete",
    "DataPipelineConfirmDeleteMsg",
    "DataPipelineCancel",
    "DataPipelineDelete",
    "DataPipelineCreatedSuccess",
    "DataPipelineCreateError",
    "DataPipelineUpdatedSuccess",
    "DataPipelineUpdateError",
    "DataPipelineDeletedSuccess",
    "DataPipelineDeleteError",
    "DataPipelineExecutionStarted",
    "DataPipelineExecutionError",
    "DataPipelineLoadError",
    "DataPipelineLoadAgentsError",
    "DataPipelineWebhookConfigRequired",
    "DataPipelineEndpointRequired",
    "DataPipelineSelectJsonFile",
    "DataPipelineFileReadError",
    "DataPipelineInvalidWorkflow",
    "DataPipelineImportHeader",
    "DataPipelineImportMsg",
    "DataPipelinePipelineNameInput",
    "DataPipelineTargetAgentInput",
    "DataPipelineNameAgentRequired",
    "DataPipelineImportedSuccess",
    "DataPipelineImportFailed",
    "DataPipelineImportMinJsonHeader",
    "DataPipelineImportMinJsonMsg",
    "DataPipelineCreatedFromMinJson",
    "DataPipelineCreationFailed",
    "DataPipelineImportError",
    "DataPipelineSelectFileType",
    "DataPipelineWebhookMissingData",
    "DataPipelineInvalidPayloadJson",
    "DataPipelineWebhookTestSuccess",
    "DataPipelineWebhookTestFailed",
    "DataPipelineWebhookTestError",
    "DataPipelineEveryXMinutes",
    "DataPipelineCronPrefix",
    "DataPipelineUnknownSchedule",

    "IntegrationsConfigSaved",
    "IntegrationsConfigError",
    "IntegrationsDeactivated",
    "IntegrationsAutoSaved",
    "IntegrationsSavedHeader",
    "IntegrationsSavedMsg",
    "IntegrationsErrorHeader",
    "IntegrationsErrorMsg",
    "IntegrationsAccessGranted",
    "IntegrationsSuccess",
    "IntegrationsLoginAgain",
    "IntegrationsAccessDenied",
    "IntegrationsApiKey",

    // agent-setting.page
    "AgentSettingTitle",
    "AgentSettingDeleteAgent",
    "AgentSettingSave",
    "AgentSettingPinAgent",
    "AgentSettingPinAgentDesc",
    "AgentSettingSystemPrompt",
    "AgentSettingSystemPromptDesc",
    "AgentSettingSystemPromptPlaceholder",
    "AgentSettingCustomInstructions",
    "AgentSettingCustomInstructionsDesc",
    "AgentSettingCustomInstructionsPlaceholder",
    "AgentSettingExpertiseAreas",
    "AgentSettingExpertiseDesc",
    "AgentSettingAddArea",
    "AgentSettingHowToManageKnowledge",
    "AgentSettingKnowledgeTip1",
    "AgentSettingKnowledgeTip2",
    "AgentSettingKnowledgeTip3",
    "AgentSettingKnowledgeTip4",
    "AgentSettingDropFiles",
    "AgentSettingDropFilesFormats",
    "AgentSettingCurrentKnowledge",
    "AgentSettingTools",
    "AgentSettingDeleteAgentDesc",
    "AgentSettingDiscardChanges",
    "AgentSettingDiscardChangesMsg",
    "AgentSettingCancel",
    "AgentSettingDiscard",
    "AgentSettingSavingChanges",
    "AgentSettingChangesSaved",
    "AgentSettingSaveError",
    "AgentSettingAddExpertise",
    "AgentSettingExpertisePlaceholder",
    "AgentSettingAdd",
    "AgentSettingDeleteAgentConfirm",
    "AgentSettingDelete",
    "AgentSettingNoProjectConfigured",
    "AgentSettingFileAdded",
    "AgentSettingUploadFailed",
    "AgentSettingChatFilesAdded",
    "AgentSettingLtmUploaded",
    "AgentSettingFileRemoved",
    "AgentSettingFileRemoveFailed",
    "AgentSettingToolEmail",
    "AgentSettingToolDatabase",
    "AgentSettingToolIndexSearch",
    "AgentSettingToolUrlParser",
    "AgentSettingToolCvParser",
    "AgentSettingToolCall",
    "AgentSettingToolSms",
    "AgentSettingToolReminder",

    // agent-tool.page
    "AgentToolCommunicationType",
    "AgentToolPhone",
    "AgentToolEmail",
    "AgentToolSMS",
    "AgentToolPhoneNumber",
    "AgentToolYourName",
    "AgentToolEnterYourName",
    "AgentToolEnterYourEmail",
    "AgentToolURL",
    "AgentToolEnterURLLink",
    "AgentToolOrder",
    "AgentToolUploadFile",
    "AgentToolChooseFile",
    "AgentToolSelectFromLocalFiles",
    "AgentToolFileUploaded",
    "AgentToolPostalCode",
    "AgentToolEnterPostalCode",
    "AgentToolSearch",
    "AgentToolSearchFor",
    "AgentToolSubject",
    "AgentToolEnterSubject",
    "AgentToolMessage",
    "AgentToolEnterMessage",
    "AgentToolScheduledDatetime",
    "AgentToolSend",
    "AgentToolAgentEmailAddress",
    "AgentToolAgentEmailDesc",
    "AgentToolCopyEmail",
    "AgentToolCreateWorkflow",
    "AgentToolDocGeneratorNote",
    "AgentToolBrowserLivestream",
    "AgentToolBrowserLivestreamDesc",
    "AgentToolOpenLivestream",
    "AgentToolSuccess",
    "AgentToolEmailAddressCopied",
    "AgentToolError",
    "AgentToolFailedToCopy",
    "AgentToolCreatingWorkflow",
    "AgentToolWorkflowExists",
    "AgentToolEmailWorkflowExists",
    "AgentToolWorkflowCreated",
    "AgentToolWorkflowCreationError",
    "AgentToolInvalidCountryCode",
    "AgentToolInvalidCountryCodeMsg",
    "AgentToolNameMaxLength",
    "AgentToolNameOnlyAlphanumeric",
    "AgentToolPhoneDigitsRange",
    "AgentToolPhoneNoSpacesDashes",
    "AgentToolInvalidUrl",
    "AgentToolDateWarning",
    "AgentToolDateWithin30Days",
    "AgentToolPostalCodeDigitsRange",
    "AgentToolPostalCodeOnlyNumbers",
    "AgentToolSearchMinLength",
    "AgentToolSearchMaxLength",
    "AgentToolSubjectMinLength",
    "AgentToolSubjectMaxLength",
    "AgentToolInvalidEmail",
    "AgentToolEmailTooLong",
    "AgentToolMessageMinLength",
    "AgentToolMessageMaxLength",
    "AgentToolInvalidPhoneNumber",
    "AgentToolInvalidPhoneNumberMsg",
    "AgentToolPhoneDigitsRangeMsg",
    "AgentToolValidationError",
    "AgentToolMissingInputs",
    "AgentToolMissingInputsMsg",
    "AgentToolPayloadError",
    "AgentToolPayloadErrorMsg",
    "AgentToolInvalidPhoneE164Msg",
    "AgentToolProcessing",
    "AgentToolFailure",
    "AgentToolSomethingWentWrong",
    "AgentToolUploadError",

    // tool-selection components
    "ToolSelectionTitle",
    "ToolSelectionSubtitle",
    "ToolSelectionEmail",
    "ToolSelectionEmailReady",
    "ToolSelectionEmailNotReady",
    "ToolSelectionPremiumFeature",
    "ToolSelectionDatabase",
    "ToolSelectionDatabaseReady",
    "ToolSelectionDatabaseNotReady",
    "ToolSelectionIndex",
    "ToolSelectionIndexReady",
    "ToolSelectionIndexNotReady",
    "ToolSelectionUrlParser",
    "ToolSelectionUrlParserDesc",
    "ToolSelectionCvParser",
    "ToolSelectionCvParserDesc",
    "ToolSelectionCall",
    "ToolSelectionCallReady",
    "ToolSelectionCallNotReady",
    "ToolSelectionSms",
    "ToolSelectionSmsReady",
    "ToolSelectionSmsNotReady",
    "ToolSelectionReminder",
    "ToolSelectionReminderDesc",
    "ToolSelectionModalTitle",
    "ToolSelectionModalConfirm",

    "CommListConfirmContact",
    "CommListConfirmContactMsg",
    "CommListCancel",
    "CommListYesStart",
    "CommListConfirmDelete",
    "CommListConfirmDeleteMsg",
    "CommListMoreContactsLoaded",
    "CommListNoMoreContacts",
    "CommListErrorLoadingContacts",
    "CommListConfirmSend",
    "CommListConfirmSendMsg",
    "CommListOkay",
    "CommListPotentialHtmlBody",
    "CommListFilterBlacklist",
    "CommListFilterBlacklistMsg",
    "CommListYes",
    "CommListNo",
    "CommListChooseWorkflow",
    "CommListChooseWorkflowMsg",
    "CommListEstimatedTime",
    "CommListLoadingInit",
    "CommListLoadingReset",
    "CommListLoadingApplicants",
    "CommListLoadingCustomers",
    "CommListLoadingCollecting",
    "CommListLoadingDetails",
    "CommListLoadingApplicantProgress",
    "CommListLoadingMerging",
    "CommListLoadingProcessing",
    "CommListLoadingHierarchy",
    "CommListLoadingActivities",

    "InsightsTitle",
    "InsightsNoConversionData",
    "InsightsExportJobTitle",
    "InsightsExportDate",
    "InsightsExportTime",
    "InsightsExportDuration",
    "InsightsExportClicks",
    "InsightsExportAnswers",
    "InsightsExportActions",
    "InsightsExportLink",
    "InsightsExportDocuments",
    "InsightsExportDevice",
    "InsightsExportBrowser",
    "InsightsExportTest",
    "InsightsExportSheetName",
    "InsightsReporting",
    "InsightsOneWeek",
    "InsightsTwoWeeks",
    "InsightsThreeWeeks",
    "InsightsCancel",
    "InsightsPleaseWait",

    "accountCreatedTitle",
    "accountCreatedSubtitle",
    "accountCreatedContent1",
    "accountCreatedContent2",
    "emailChipLabel",
    "goToLoginButton",
    "onlineStatus",
    "newChatButton",
    "powerUpsTitle",
    "powerUpsSeeAll",
    "recentHistory",
    "uploadCompanyKnowledge",
    "lockedOverlayText",
    "signInWithGoogle",
    "signInWithGmail",
    "signInWithMicrosoft",
    "signInWithOutlook",
    "signOut",
    "addNewAccount",
    "deleteAccount",
    "aboutUs",
    "contactUs",
    "privacy",
    "agreement",
    "putYourName",
    "save",
    "filterPizza",
    "exampleImage",
    "aiEmployees",
    "Einloggen",
    "WilkommenZurück",
    "emailInvalid",
    "ForgotPassword",
    "KeinKonto",
    "SignUp",
    "signInWithApple",
    "OnlineAndReady",
    "noPhoneNumberAvailable",
    "pressForSpeech",
    "profile",
    "pleaseSetYourName",
    "userId",
    "registeredAt",
    "register",
    "registerSubtitle",
    "referral",
    "referralPlaceholder",
    "createAccount",
    "alreadyHaveAccount",
    "login",
    "uploadProfile",
    "choosePhotoProfile",
    "photoCanBeChanged",
    "pleaseChoosePhoto",
    "selectFromLocalFiles",
    "cropPhoto",
    "welcomeToChatMona",
    "yourPersonalAIAssistant",
    "LoginWithGoogle",
    "LoginWithMicrosoft",
    "LoginWithApple",
    "Previous",
    "NameCanNotBeEmpty",
    "NameCanNotBeDuplicate",
    "Open",
    "Rename",
    "Delete",
    "Move",
    "CompanyKnowledge",
    "CreateFolder",
    "UploadFile",
    "Search",
    "FolderAlreadyExists",
    "FileAlreadyExists",
    "FolderAlreadyExistsWantToOverwrite",
    "FileAlreadyExistsWantToOverwrite",
    "Overwrite",
    "OverwriteFailed",
    "OverwriteFailedMessage",
    "RenameFolder",
    "RenameFile",
    "FolderName",
    "FileName",
    "EnterNewFolderName",
    "EnterNewFileName",
    "EnterFolderName",
    "EnterFileName",
    "NewFolder",
    "UploadFailed",
    "UploadFailedMessage",
    "DeleteFolder",
    "DeleteFile",
    "AreYouSureYouWantToDeleteThisFolder",
    "AreYouSureYouWantToDeleteThisFile",
    "DeleteFailed",
    "DeleteFailedMessage",
    "NetworkError",
    "NetworkErrorMessage",
    "Confirm",
    "Close",
    "Electrician",
    "Lawyers",
    "Notaries",
    "TaxAdvisors",
    "Doctors",
    "Architects",
    "Physiotherapists",
    "Designers",
    "Journalists",
    "IT",
    "Educator",
    "Trainer",
    "Artist",
    "Handyman",
    "Tutor",
    "Housing",
    "TransportAndWarehouse",
    "Musician",
    "StoreOwner",
    "Restaurant",
    "Logistic",
    "EventManager",
    "MarketingAndPR",
    "HRAndRecruiting",
    "Other",
    "Developer",
    "CEO",
    "HR",
    "Sales",
    "Marketing",
    "SelfEmployed",
    "ChooseYourJobTitle",
    "ChooseYourCompanySize",
    "ChooseYourIndustry",
    "TypeYourFirstAndLastName",
    "TypeYourCompanyWebsite",
    "And",
    "AgreeWith",
    "OfChatMona",
    "WelcomeToChatMona",
    "WeAreGladToHaveYouOnboard",
    "GettingStarted",
    "PleaseAnswerAFewQuestions",
    "YourRole",
    "PleaseSelectFromTheOptionsAbove",
    "WhatIsYourCompanySize",
    "PleaseSelectTheSizeOfYourCompany",
    "WhichIndustryDoYouWorkIn",
    "PleaseSelectYourIndustry",
    "WhatAreYourPrimaryObjectivesWithAI",
    "PleaseDescribeYourGoalsInAFewWords",
    "WhatIsYourFirstAndLastName",
    "CompanyWebsite",
    "IfYourCompanyHasAWebsitePleaseEnterTheURL",
    "Congratulations",
    "GeneratingYourAIAgents",
    "Next",
    "Done",
    "Waiting",
    "MONAAI",
    "MONAAIFounded",
    "MONAAIAgents",
    "MONAAILearnMore",
    "OurJourney",
    "WhatShapesMona",
    "Mona2020",
    "Mona2022",
    "Mona2023",
    "Mona012024",
    "Mona102024",

    "ChatHistoryClose",
    "ChatHistoryTitle",
    "ChatHistoryNewChat",
    "ChatHistoryNew",
    "ChatHistoryLoading",
    "ChatHistoryMessages",
    "ChatHistoryNoHistory",
    "ChatHistoryNoHistoryDesc",
    "ChatHistoryStartNew",

    "InterviewCohortsProcessFlow",
    "InterviewCohortsDropoutAnalysis",
    "InterviewCohortsDropoffByQuestion",
    "InterviewCohortsTotalApplicants",
    "InterviewCohortsQuestion",
    "InterviewCohortsApplicants",
    "InterviewCohortsDropoff",
    "InterviewCohortsNoData",
    "InterviewCohortsNumberOfApplicants",
    "InterviewCohortsApplicantsDroppedOff",
    "InterviewCohortsShowCancellations",
    "InterviewCohortsHideCancellations",
    "InterviewCohortsCancellation",

    "AgentDashboardThinkingMode",
    "AgentDashboardInternetMode",
    "AgentDashboardTools",
    "AgentDashboardThinking",
    "AgentDashboardInternet",
    "AgentDashboardBrowserAutomationTitle",
    "AgentDashboardMemory",
    "AgentDashboardFeedback",
    "AgentDashboardBrowserAutomationToolTitle",
    "AgentDashboardSalesforceUpdate",
    "AgentDashboardPremiumFeature",
    "AgentDashboardUpgrade",
    "AgentDashboardLegalNoticeSms",
    "AgentDashboardLegalNoticeEmail",
    "AgentDashboardFileTypeImage",
    "AgentDashboardFileTypeDocument",
    "AgentDashboardFileTypeCode",
    "AgentDashboardFileTypeData",
    "AgentDashboardFileTypeSpreadsheet",
    "AgentDashboardFileTypeFile",
    "AgentDashboardSearchContextFull",
    "AgentDashboardSearchContextPosition",
    "AgentDashboardCsvHeaderName",
    "AgentDashboardDefaultToolName",
    "AgentDashboardBrowserAutomationName",
    "AgentDashboardGeneralAssistant",
    "AgentDashboardDefaultSystemPrompt",
    "AgentDashboardNoProjectConfigured",
    "AgentDashboardOK",

    "ApplicantsWorkflowContact",
    "ApplicantsAIFilter",
    "ApplicantsDataTransferInProgress",
    "ApplicantsProgress",
    "ApplicantsApplicantsFetched",
    "ApplicantsDataImportTestMode",
    "ApplicantsApplicantsImported",
    "ApplicantsStatusLabel",
    "ApplicantsReadingFile",
    "ApplicantsProcessingData",
    "ApplicantsImportComplete",
    "ApplicantsTestModeNote",
    "ApplicantsTalentionExportInProgress",
    "ApplicantsProgressSuccessFailed",
    "ApplicantsInitializing",
    "ApplicantsExportingToTalention",
    "ApplicantsExportComplete",
    "ApplicantsTalentionBatchNote",
    "ApplicantsSystemStatus",
    "ApplicantsEditStatus",
    "ApplicantsFilterByMona",
    "ApplicantsSelectPosition",
    "ApplicantsSearchPosition",
    "ApplicantsNoPositionsFound",
    "ApplicantsNoCreditsHeader",
    "ApplicantsNoCreditsMsg",
    "ApplicantsBuyCredits",
    "ApplicantsOK",
    "ApplicantsCancel",
    "ApplicantsCreditsLoadError",
    "ApplicantsNotEnoughCredits",
    "ApplicantsUnlocked",
    "ApplicantsUnlockFailed",
    "ApplicantsActionError",
    "ApplicantsExportHeader",
    "ApplicantsExportMsg",
    "ApplicantsExportPlaceholder",
    "ApplicantsLockedHeader",
    "ApplicantsLockedMsg",
    "ApplicantsDataTransferHeader",
    "ApplicantsDataTransferMsg",
    "ApplicantsContinue",
    "ApplicantsStartingTransfer",
    "ApplicantsTransferError",
    "ApplicantsFetchedCount",
    "ApplicantsExportedJson",
    "ApplicantsExportedJsonChunks",
    "ApplicantsStartingImportTest",
    "ApplicantsTestImportSuccess",
    "ApplicantsImportFailed",
    "ApplicantsDistanceCalcFailed",
    "ApplicantsStartingImportArea",
    "ApplicantsFullModeProcessing",
    "ApplicantsImportCompleted",
    "ApplicantsImportTestHeader",
    "ApplicantsImportTestMsg",
    "ApplicantsSelectFile",
    "ApplicantsTalentionExportHeader",
    "ApplicantsTalentionExportChoose",
    "ApplicantsTalentionTest5",
    "ApplicantsTalentionExportAll",
    "ApplicantsTalentionStep1",
    "ApplicantsTalentionStep2",
    "ApplicantsTalentionProcessingAll",
    "ApplicantsTalentionStep3",
    "ApplicantsTalentionTestConnection",
    "ApplicantsTalentionConnectionOk",
    "ApplicantsTalentionConnectionFail",
    "ApplicantsNoApplicantsForTest",
    "ApplicantsTalentionTestHeader",
    "ApplicantsTalentionTestMsg",
    "ApplicantsTalentionTestExport",
    "ApplicantsTalentionTestExporting",
    "ApplicantsTalentionTestSuccess",
    "ApplicantsTestGoogleMaps",
    "ApplicantsRecontactHeader",
    "ApplicantsRecontactMsg",
    "ApplicantsRecontactTest",
    "ApplicantsRecontactAll",
    "ApplicantsLoadingApplicants",
    "ApplicantsNoMustermannFound",
    "ApplicantsDeleteHeader",
    "ApplicantsDeleteMustermannMsg",
    "ApplicantsDelete",
    "ApplicantsErrorPrefix",
    "ProfilePlanBilling",
    "ProfileCVFilter",
    "ProfileNoLocations",
    "ProfileLocationName",
    "ProfileLocationAddress",
    "ProfileLocationPhone",
    "ProfileLocationEmail",
    "ProfileYears",
    "ProfileDays",
    "ProfileCurrentAPIKeys",
    "ProfileAPIKeysDesc",
    "ProfileAPIKey",
    "ProfileActive",
    "ProfileInactive",
    "ProfileKeyLabel",
    "ProfileSecureKeyWarning",
    "ProfileDelete",
    "ProfileCoreDataAccess",
    "ProfileReadApplicants",
    "ProfilePushApplicants",
    "ProfileReadJobOffers",
    "ProfilePushJobOffers",
    "ProfileReadData",
    "ProfilePushData",
    "ProfileAgentManagement",
    "ProfileReadAgents",
    "ProfilePushAgents",
    "ProfileExecuteAgents",
    "ProfileExecuteWorkflow",
    "ProfileToolManagement",
    "ProfileReadTools",
    "ProfileManageTools",
    "ProfileMatchingAnalytics",
    "ProfileReadMatching",
    "ProfileCreateMatching",
    "ProfileReadAnalytics",
    "ProfileDocumentProcessing",
    "ProfileParsing",
    "ProfileCommunication",
    "ProfileReadCommunication",
    "ProfileAdministrative",
    "ProfileManageAPIKeys",
    "ProfileSystemAdmin",
    "ProfileLongLivedAPIKey",
    "ProfileStatus",
    "ProfileGenerateNewAPIKey",
    "ProfileLogout",
    "ProfileWorkflow",
    "ProfileEditWorkflow",
    "ProfileEmailAutomationSaved",
    "ProfileEmailAutomationFailed",
    "ProfilePayPerUse",
    "ProfileCredits",
    "ProfileBasic",
    "ProfilePopular",
    "ProfileBestValue",
    "ProfilePremium",
    "ProfilePrivacyPolicy",
    "ProfileTerms",
    "ProfileImprint",
    "ProfileReadyToHelp",
    "ProfileNoEmailAddress",
    "ProfileEmailCopied",
    "ProfileCopyFailed",
    "ProfileBrandingCreated",
    "ProfileBrandingError",
    "ProfileAPIKeyGenerated",
    "ProfileAPIKeyGenerateFailed",
    "ProfileSoundSaved",
    "ProfileUploadFailed",
    "ProfileUpdatedSuccessfully",
    "ProfileSaved",
    "ProfileSaveError",
    "ProfileSuccess",
    "ProfileSaveFailed",
    "CommDashStandardWorkflows",
    "CommDashOkay",
    "CommDashInitializingWorkflows",
    "CommDashStandardWorkflowsCreated",
    "CommDashCreateStandardWorkflows",
    "CommDashWorkflowsExistConfirm",
    "CommDashConfirm",
    "CommDashCreate",
    "CommDashWrongFormat",
    "UploadImported",
    "UploadJobPost",
    "UploadApplicantsImported",
    "UploadAdsUpdated",
    "UploadConfirmContact",
    "UploadProcessCannotBeStopped",
    "UploadYesStart",
    "UploadContactingWithJobOffer",
    "UploadCorrectJobOffer",
    "AppInfoUnknown",
    "AppInfoGeneral",
    "AppInfoDataSaved",
    "AppInfoEmployeeCreated",
    "AppInfoEmailSent",
    "AppInfoConfirmArchive",
    "AppInfoConfirmDelete",
    "AppInfoCallError",
    "AppInfoConfirmPart2",
    "AppInfoYesSend",
    "AppInfoContactingEmployee",
    "AppInfoNoPersonnelNumber",
    "AppInfoNoDocs",
    "AppInfoNoDocsDocx",
    "AppInfoSameLanguage",
    "AppInfoSameLanguageMsg",
    "AppInfoTimeout",
    "AppInfoVideoOpening",
    "AppInfoNoCVUploaded",
    "AppInfoNoInterview",
    "AppInfoProfileCreated",
    "AppInfoProfileCreating",
    "AppInfoSelectWorkflow",
    "AppInfoWorkflowStarted",
    "AppInfoWorkflowStartedMsg",
    "AppInfoNoWorkflows",
    "AppInfoNoWorkflowsMsg",
    "AppInfoTimelineError",
    "AppInfoTimelineSuccess",
    "AppInfoScheduleAppointment",
    "AIAnalyse",
    "AIFitAnalyse",
    "Zusammenfassung",
    "Anforderungen",
    "Stärken",
    "Risiken",
    "KeineAIAnalyseVorhanden",
    "BewerteteJobs",
    "Bestanden",
    "NichtBestanden",
    "BesterMatch",
    "ErkanntesProfilAusCv",
    "Jahre",
    "AktuellePosition",
    "Warnhinweise",
    "Abgelehnt",
    "Begründung",
    "Bedenken",
    "Vorhanden",
    "Fehlend",
    "Kompatibel",
    "NichtKompatibel",
    "Ausreichend",
    "NichtAusreichend",
    "Erkannt",
    "NichtErkannt",
    "Rechtskonformität",
    "Problematisch",
    "Kosten",
    "KeineCVFilterErgebnisse",
    "OhneStandort",
    "PasswortErstellen",
    "PasswortErstellenBeschreibung",
    "PasswortWiederholen",
    "AccountErstellen",
    "PasswortRegelnFehler",
    "PasswortStimmenNichtUeberein",
    "EinladungsLinkBeschreibung",
    "Kopiert",
    "FehlerKopieren",
    "Home",
    "ARS",
    "Daten Import",
    "CanvasElements",
    "CanvasNote",
    "CanvasRectangle",
    "CanvasCircle",
    "CanvasTextBox",
    "CanvasArrow",
    "CanvasMarker",
    "AddNote",
    "LayerFront",
    "LayerBack",
    "CanvasSavingConfig",
    "CanvasSavingConfigSubtitle",
    "CanvasItemsOf",
    "CanvasItems",
    "CanvasAgentsAndMembers",
    "CanvasTeams",
    "CanvasWorkflowsAndNodes",
    "CanvasSavingInfoMsg",
    "CanvasConnectTeams",
    "FitToView",
    "SwitchOrganization",
    "ActiveConnections",
    "WorkflowSimulation",
    "SimulationInputPlaceholder",
    "NoWorkflowSelected",
    "StartingTestExecution",
    "DataValidation",
    "ErrorInStep",
    "Executed",
    "NoAgentConfigured",
    "WarningAgentMissing",
    "NoResponse",
    "Response",
    "AgentResponseReceived",
    "Characters",
    "AgentExecutionFailed",
    "NoToolConfigured",
    "WarningToolMissing",
    "Result",
    "ToolExecutedSuccessfully",
    "ToolExecutionFailed",
    "ToolSendEmail",
    "ToolSendSMS",
    "ToolParseCv",
    "ToolDbQuery",
    "ToolDbUpdate",
    "ToolCreateProfile",
    "ToolMatching",
    "ToolCalendar",
    "ToolPhoneCall",
    "ConditionChecked",
    "True",
    "False",
    "InputData",
    "ConditionEvaluated",
    "ApiCall",
    "ApiSuccess",
    "ApiCallFailed",
    "EmailTestMode",
    "To",
    "Subject",
    "Content",
    "EmailPreparedTestMode",
    "TransformFailed",
    "DataTransformed",
    "Before",
    "After",
    "TransformSuccess",
    "FilesUploaded",
    "Knowledge",
    "More",
    "StartChat",
    "Public",
    "Restricted",
    "ApprovalRequired",
    "UsersAuthorized",
    "EmailsAuthorized",
    "CreatedBy",
    "YourAgents",
    "PersonalizedAgentsDesc",
    "OwnAgent",
    "Less",
    "Details",
    "Setup",
    "PrebuiltSpecialistsDesc",
    "PinAgent",
    "SystemAgents",
    "SystemAgentsDesc",
    "Profile",
    "Experience",
    "Specialist",
    "Open",
    "CanvasClickTeamsToConnect",
    "CanvasActiveAgents",
    "CanvasWorkflows",
    "CanvasKIAgentsAndMembers",
    "CanvasAddAgent",
    "CanvasNoAgentsAssigned",
    "CanvasNoWorkflows",
    "CanvasNoActiveAgents",
    "WbConfigureTriggerFor",
    "WbTriggerManual",
    "WbTriggerTimeBased",
    "WbTriggerInterval",
    "WbTriggerApiWebhook",
    "WbNext",
    "WbSave",
    "WbTriggerSaved",
    "WbConfigureSchedule",
    "WbConfigureInterval",
    "WbScheduleTimePlaceholder",
    "WbScheduleIntervalPlaceholder",
    "WbConfigureApiWebhook",
    "WbApiEndpointPlaceholder",
    "StartFromScratch",
    "CreateBlankWorkflow",
    "LocTeamsLocationsAndTeams",
    "LocTeamsLocation",
    "LocTeamsLocations",
    "LocTeamsCreateLocation",
    "LocTeamsRefresh",
    "LocTeamsLoadingLocations",
    "LocTeamsNoLocations",
    "LocTeamsNoLocationsHint",
    "LocTeamsUnassigned",
    "LocTeamsUnassignedAgents",
    "LocTeamsSelectLocationFirst",
    "LocTeamsOnline",
    "LocTeamsPhysical",
    "LocTeamsAssignedAgents",
    "LocTeamsNoAgentsAssigned",
    "LocTeamsAssignAgent",
    "LocTeamsTeams",
    "LocTeamsMembers",
    "LocTeamsNoTeamsAtLocation",
    "LocTeamsRemoveFromLocation",
    "LocTeamsEditLocation",
    "LocTeamsDeleteLocation",
    "LocTeamsSaveLocation",
    "LocTeamsStreet",
    "LocTeamsZip",
    "LocTeamsCity",
    "LocTeamsCountry",
    "LocTeamsTimezone",
    "LocTeamsLocationSaved",
    "LocTeamsLocationDeleted",
    "LocTeamsDeleteLocationTitle",
    "LocTeamsDeleteLocationMsg",
    "LocTeamsLocationSaveFailed",
    "LocTeamsLocationDeleteFailed",
    "LocTeamsLocationInUseTitle",
    "LocTeamsLocationInUseMsg",
    "LocTeamsUsageTeams",
    "LocTeamsUsagePeople",
    "LocTeamsUsageAgents",
    "LocTeamsUsageLocationTeams",
    "LocTeamsUsageProfile",
    "ChatWith",
    "AskAnythingAbout",
    "KeyResponsibilities",
    "OptimizationTips",
    "SummarizeStructure",
    "AskAboutThis",
    "ChatError",
    "Back",
    "Forward",
    "Overview",
    "Edit",
    "Cancel",
    "Create",
    "Update",
    "Goal",
    "Guidelines",
    "NoItems",
    "Yet",
    "AIAssistant",
    "ChatAboutThis",
    "WhatAreKeyResponsibilities",
    "HowCanIOptimize",
    "SummarizeCurrentStructure",
    "Name",
    "EnterDescriptiveName",
    "NameRequired",
    "ParentDepartment",
    "NoDepartmentUnassigned",
    "ParentDivision",
    "NoDivisionUnassigned",
    "Location",
    "SelectLocation",
    "NoLocationsAvailable",
    "LocationType",
    "PhysicalOffice",
    "OnlineRemote",
    "StreetAddress",
    "EnterStreetAddress",
    "HouseNumber",
    "EnterHouseNumber",
    "Address2Optional",
    "ApartmentSuiteFloor",
    "City",
    "EnterCity",
    "ZipCode",
    "EnterZipCode",
    "Country",
    "EnterCountry",
    "Timezone",
    "CompanyDataEnrichment",
    "Searching",
    "SearchCompanyData",
    "EnterCompanyNameHint",
    "Website",
    "Industry",
    "IndustryPlaceholder",
    "EmployeeCount",
    "Founded",
    "Revenue",
    "Headquarters",
    "HeadquartersPlaceholder",
    "EnrichedCompanyDescription",
    "ApplyToAdditionalInfo",
    "OverallGoal",
    "GoalPurpose",
    "WhatIsMainObjective",
    "DescribeGoalPlaceholder",
    "GuidelinesAndPrinciples",
    "OperatingPrinciples",
    "EnterGuidelinesPlaceholder",
    "AdditionalInformation",
    "AnyOtherContext",
    "AddContextPlaceholder",
    "ExtendedContext",
    "DetailedCompanyInfo",
    "EnterComprehensiveContext",
    "SelectOrganization",
    "YouHave",
    "OrganizationsSelectOrCreate",
    "SearchOrganizations",
    "DeptShort",
    "Teams",
    "People",
    "NoOrganizationFound",
    "CreateNewOrganization",
    "ShowThinkingProcess",
    "ThinkingProcess",
    "Steps",
    "LoadMore",
    "Remaining",
    "AllLocations",
    "LocationsSelected",
    "AllTeams",
    "TeamsSelected",
    "NoLocation",
    "NotAssigned",
    "WbSwitchOrganization",
    "WbOrgAiPlaceholder",
    "WbLoading",
    "WbWebhookSecretPlaceholder",
    "WbOrganigrammSnapshot",
    "WbNoSnapshotYet",
    "WbIntegrations",
    "WbFile",
    "WbThinking",
    "WbWeb",
    "WbConnected",
    "WbCopy",
    "WbRemove",
    "WbSchedule",
    "WbDaily",
    "WbWeekdays",
    "WbMondays",
    "WbEvery4Hours",
    "WbCronExpression",
    "WbResetSimulation",
    "CanvasSyncedAgent",
    "CanvasActive",
    "CanvasInactive",
    "CanvasDragToReorganize",
    "WbOrganization",
    "WbShopifyStorePlaceholder",

    "LiDefaultConnectionTemplate",
    "LiDefaultMessageTemplate",
    "LiApiClassicShort",
    "LiApiSalesNavShort",
    "LiApiRecruiterShort",
    "FileAddedTraining",
    "UploadFailed",
    "FileRemoved",
    "CouldNotRemoveFile",
    "CancelCampaign",
    "CancelCampaignConfirm",
    "No",
    "YesCancel",
    "CancellingCampaign",
    "CampaignCancelled",
    "ErrorCancelling",
    "StatusQueued",
    "StatusSent",
    "StatusAccepted",
    "StatusFailed",
    "StatusCancelled",
    "LinkedInConnectedSuccess",
    "LinkedInConnectionFailed",
    "LiSwitchAccountTitle",
    "LiSwitchAccountMsg",
    "SwitchAccount",
    "PhoneVerifiedSuccess",
    "VerificationInProgress",
    "OnlyPdfDocxTxtAllowed",
    "NoTextFoundTryAi",
    "NoTextExtractedClickAi",
    "ErrorReadingTryAi",
    "ErrorReadingClickAi",
    "TooManyTokens",
    "SystemPromptReplaced",
    "TextAppended",
    "NoFileToAnalyze",
    "AiAnalysisComplete",
    "AnalysisFailedTextKept",
    "ToolEmail",
    "ToolDatabase",
    "ToolIndexSearch",
    "ToolUrlParser",
    "ToolCvParser",
    "ToolCall",
    "ToolSms",
    "ToolReminder",
    "FilesAddedToChat",
    "FilesUploadedToRAG",
    "DiscardChanges",
    "DiscardChangesMsg",
    "Discard",
    "SavingChanges",
    "ChangesSaved",
    "SaveError",
    "AddExpertise",
    "ExpertisePlaceholder",
    "Add",
    "DeleteAgent",
    "DeleteAgentConfirm",
    "Delete",
    "Copied",
    "AcAiTools",
    "AcAiToolsSubtitle",
    "AcToolEmail",
    "AcToolEmailDesc",
    "AcToolDatabase",
    "AcToolDatabaseDesc",
    "AcToolIndexData",
    "AcToolIndexDataDesc",
    "AcToolUrlParser",
    "AcToolUrlParserDesc",
    "AcToolCvParser",
    "AcToolCvParserDesc",
    "AcToolCall",
    "AcToolCallDesc",
    "AcToolSms",
    "AcToolSmsDesc",
    "AcToolReminder",
    "AcToolReminderDesc",
    "AcToolLinkedIn",
    "AcToolLinkedInDesc",
    "AcPrepareTemplate",
    "AcCreateConfig",
    "AcActivateAi",
    "AcSaving",
    "AcFinalizing",
    "AcResetSearch",
    "AcAddAgent",
    "AcLivestreamAvailable",
    "AcContactInfoFound",
    "AcWorkExperience",
    "AcRecipient",
    "AcMessage",
    "AcSaveToMemory",
    "AcMemory",
    "AcDataPipeline",
    "AcCallSuccessful",
    "AcDocGenNoFiles",
    "AcToolRequired",
    "AcToolsTooltip",
    "AcFileTooltip",
    "AcVoiceTooltip",
    "AcAgentsCanMakeMistakes",
    "AcOptional",
    "AcRequired",
    "AcClickCreateToSave",
    "AcCreating",
    "AcCreated",
    "AcCreate",
    "AcAgentRequiresIntegration",
    "AcRequiredIntegration",
    "AcIntegration",
    "AcConfigureIntegrationHint",
    "AcIntegrationConnected",
    "AcOpenIntegrations",
    "AcCheckConnection",
    "AcConnectLinkedInDesc",
    "AcConnectLinkedInHint",
    "AcLinkedInConnected",
    "AcWaitingForConnection",
    "AcConnectLinkedIn",
    "AcGreetingMessage",
    "AcGreetingPlaceholder",
    "AcCommunicationStyle",
    "AcSkip",
    "AcSaved",
    "AcSave",
    "AcDragFilesOr",
    "AcChooseFiles",
    "AcFileTypes",
    "AcUpload",
    "AcToolsInfoHint",
    "AcPipelineInfoHint",
    "AcNoPipeline",
    "AcEmailInbox",
    "AcWebhook",
    "AcHelloIAm",
    "AcHowCanIHelpToday",
    "AcYour",
    "AcISpecializeIn",
    "AcVariousAreas",
    "AcAndHappyToHelp",
    "AcAsPersonalizedAgent",
    "AcHelloHowCanIHelp",
    "AcHowCanIHelp",
    "AcErrorOccurred",
    "AcVoiceMessageError",
    "AcUnknownError",
    "AcAppointmentError",
    "AcCreditsExhaustedFull",
    "AcSendMessageError",
    "AcSmsSentSuccessfully",
    "AcCallStartedSuccessfully",
    "AcToolActivated",
    "AcToolActivatedMsg",
    "AcToolActivationFailed",
    "AcMaxToolsReached",
    "AcLeadsSaved",
    "AcBrowserAutomationFailed",
    "AcHowCanYouHelpMe",
    "AcWhatAreYourSkills",
    "AcLetsGetStarted",
    "AcAutoCreatedCvAgent",
    "Campaigns",
    "LoadingCampaigns",
    "NoCampaigns",
    "TotalLeads",
    "Sent",
    "Queued",
    "Failed",
    "LoadingDetails",
    "MessageTemplate",
    "Contacts",
    "NoContactData",
    "Unknown",
    "AgentSettingSave",
    "Connected",
    "NotConnected",
    "Tip",
    "LiTipSingleAccount",
    "LiStep3Title",
    "LiTipRateLimit",
    "LiMessageTemplates",
    "LiConnectionRequest",
    "LiDirectMessage",
    "LiPlaceholdersTip",
    "FirstName",
    "LastName",
    "Location",
    "Company",
    "QuickAccess",
    "DangerZone",
    "VcPhoneNumber",
    "VcConnected",
    "VcNumber",
    "Name",
    "Cancel",
    "Append",
    "Replace",
    "ExpertiseAreas",
    "AddArea",
    "KnowledgeManagement",
    "PinAgent",
    "PinAgentDesc",
    "NotetakerSettings",
    "InviteToMeeting",
    "SendTranscript",
    "SendTranscriptDesc",
    "SendAnalysis",
    "SendAnalysisDesc",
    "RecentTranscripts",
    "NoTranscriptsYet",
    "TranscriptsLoading",
    "AgentInstructions",
    "SystemPrompt",
    "SystemPromptDesc",
    "CustomInstructions",
    "CustomInstructionsDesc",
    "ExpertiseDesc",
    "HowToManageKnowledge",
    "KnowledgeTip1",
    "KnowledgeTip2",
    "KnowledgeTip3",
    "KnowledgeTip4",
    "DropFilesHere",
    "SupportedFormats",
    "CurrentAgentKnowledge",
    "AgentTools",
    "DeleteAgent",
    "DeleteAgentDesc",
    "DragFileOrClick",
    "AiAnalyzing",
    "FileReading",
    "ArsConnections",
    "ArsConnectionsDesc",
    "MonaArsModules",
    "MonaArsDesc",
    "Connected",
    "SetUp",
    "ComingSoon",
    "ShareOrSell",
    "PhoneNumberValidation",
    "PhoneNumberValidationDesc",
    "SmsSender",
    "SmsSenderDesc",
    "SmtpSetup",
    "SmtpSetupDesc",
    "AddCalendar",
    "AddCalendarDesc",
    "ImapInbox",
    "ImapInboxDesc",
    "ConnectLinkedIn",
    "ConnectLinkedInDesc",
    "OpenMonaLive",
    "OpenMonaLiveDesc",
    "MonaNotetaker",
    "MonaNotetakerDesc",
    "ModuleCouldNotOpen",
    "LinkedInConnectedSuccess",
    "LinkedInConnectFailed",
    "LinkedInConnectStartFailed",
    "JobPostings",
    "JobPostingsDesc",
    "Candidates",
    "CandidatesDesc",
    "ShortlistDesc",
    "MonaPool",
    "MonaPoolDesc",
    "ExcelImport",
    "ExcelImportBeschreibung",
    "VorlageHerunterladen",
    "CVUploadHinweis",
    "CSVImport",
    "CSVImportBeschreibung",
    "CVUploadBeschreibung",
    "PDFsHierherZiehen",
    "MehrereErlaubt",
    "Fehler",
    "CVsWerdenAnalysiert",
    "LebensläufeAnalysiert",
    "DatenUntenPrüfen",
    "EmailWeiterleitung",
    "EmailWeiterleitungBeschreibung",
    "EmailWirdGeneriert",
    "EmailAdresseGenerieren",
    "EmailSchritt1",
    "EmailSchritt2",
    "EmailSchritt3",
    "ATSIntegration",
    "ATSBeschreibung",
    "ATSVerbinden",
    "ATSVerbindenBeschreibung",
    "ZuIntegrationen",
    "ImportierteBewerber",
    "AuswahlLöschen",
    "AlleLöschen",
    "AlleÜbernehmen",
    "Quelle",
    "Bearbeiten",
    "UndWeitere",
    "WeitereBewerber",
    "WebsiteScraping",
    "TextEinfügen",
    "WebsiteScrapingBeschreibung",
    "Analysieren",
    "GefundeneStellenanzeigen",
    "AlleImportieren",
    "JobExcelBeschreibung",
    "JobCSVBeschreibung",
    "StellenanzeigEinfügen",
    "PasteJobBeschreibung",
    "StellenanzeigePlaceholder",
    "MitKIAnalysieren",
    "ErkannteInformationen",
    "StellenanzeigenImportieren",
    "ImportierteStellenanzeigen",
    "UploadErfolgreich",
    "AndereDateiHochladen",
    "OrginsLoadingUsage",
    "OrginsLoadingUsageData",
    "OrginsPreparingData",
    "OrginsLoadingAgents",
    "OrginsScanningAgentHistory",
    "OrginsUsageLoaded",
    "OrginsLoadingStopped",
    "OrginsFiguresAppearAfterLoading",
    "OrginsEndLoadingProcess",
    "OrgpageNoOrganizationsYet",
    "OrgpageNewOrganization",
    "OrgpageEdit",
    "OrgpageDelete",
    "OrgpageOverview",
    "OrgpageGraph",
    "OrgpageDashboards",
    "OrgpageInsights",
    "OrgpageAuditLogs",
    "OrgpageCopyList",
    "OrgpageChat",
    "OrgpageAssistant",
    "OrgpageClose",
    "OrgpageThinking",
    "OrgpageCreateTheseNodes",
    "OrgpageCreating",
    "OrgpageCreate",
    "OrgpageDiscard",
    "OrgpageNoStructureYet",
    "OrgpageNoStructureHint",
    "OrgpageCreateFirstNode",
    "OrgpageClipHintGraph",
    "OrgpageClipHintOverview",
    "OrgpageClipHintStructure",
    "OrgpageClipEmpty",
    "OrgpageUnnamed",
    "OrgpageNodeCount",
    "OrgpageRemoveFromList",
    "OrgpageSelectOrganization",
    "OrgpageListLoadFailed",
    "OrgpageSelectOrgFirst",
    "OrgpageDeleteOrgHeader",
    "OrgpageDeleteOrgMessage",
    "OrgpageOrgGone",
    "OrgpageOrgDeleteFailed",
    "OrgpageTeamAssignFailed",
    "OrgpageChooseOrgFirst",
    "OrgpageOrgReadFailed",
    "OrgpageTeamCreateFailed",
    "OrgpageCreateTeamAtLocationFirst",
    "OrgpageLocationSaveFailed",
    "OrgpageAiDone",
    "OrgpageAiUnreachable",
    "OrgpageAiTruncated",
    "OrgpageAiNothingNew",
    "OrgpageAiWouldCreate",
    "OrgpageAiDiscarded",
    "OrgpageAiCreated",
    "OrgpageAiFailedList",
    "OrgpageAiApplyFailed",
    "OrgpageAiSuggestion1",
    "OrgpageAiSuggestion2",
    "OrgpageAiSuggestion3",
    "OrgpageTypePerson",
    "OrgpageTypeAgent",
    "OrgpageTypeTeam",
    "OrgpageTypeDepartment",
    "OrgpageTypeDivision",
    "OrgpageTypeTrigger",
    "OrgpageTypePipeline",
    "OrgpageTypeNode",
    "OrgpageTypeGroup",
    "OrgpageTypeAiAssistant",
    "OrgpageFilterPlaceholder",
    "OrgpageMatches",
    "OrgpageClearFilter",
    "OrgpageAddToOrg",
    "OrgpageFirstNode",
    "OrgpagePeople",
    "OrgpageAI",
    "OrgpageTeams",
    "OrgpageActivity",
    "OrgpageActive",
    "OrgpageCollapse",
    "OrgpageExpand",
    "OrgpageCopy",
    "OrgpageCopying",
    "OrgpageAlreadyInCopyList",
    "OrgpageCopied",
    "OrgpageCopiedN",
    "OrgpageCopyFailed",
    "OrgpageItemGone",
    "OrgpagePasteIntoStep",
    "OrgpageCannotPaste",
    "OrgpagePasteFailed",
    "OrgpagePasted",
    "OrgpagePastedN",
    "OrgpagePastedPartial",
    "OrgpageAddToModule",
    "OrgpageAddInto",
    "OrgpageCannotAddHere",
    "OrgpageAddConfirm",
    "OrgpageAddAsWorkflow",
    "OrgpageAddWorkflowConfirm",
    "OrgpageLoadingOrganigram",
    "OrgpageNoMatches",
    "OrgpageLoadFailed",
    "OrgpageNoOrgData",
    "OrgpageLocations",
    "OrgpageShowOnMap",
    "OrgpageNoLocationsYet",
    "OrgpageEditing",
    "OrgpageInactive",
    "OrgpageLoading",
    "OrgpageDetailsFailed",
    "OrgpageDescription",
    "OrgpageGoal",
    "OrgpageNoDescription",
    "OrgpageAddAStep",
    "OrgpageStructure",
    "OrgpageStructureHint",
    "OrgpageAdd",
    "OrgpageTypeCompany",
    "OrgpageName",
    "OrgpageMembers",
    "OrgpageInside",
    "OrgpageChatWith",
    "OrgpageGuidelines",
    "OrgpageThisModule",
    "OrgpageCompanyParen",
    "OrgpageDiscardUnsaved",
    "OrgpageEditBlockedLoad",
    "OrgpageEditBlockedLoading",
    "OrgpageEditBlockedReopen",
    "OrgpageTriggerUnsynced",
    "OrgpageAddSomeoneFirst",
    "OrgpagePipelineEditNote",
    "OrgpageWhatRecipientsDo",
    "OrgpageNotRegistered",
    "OrgpageNoInstruction",
    "OrgpageRunsAfterStep",
    "OrgpageAssignedTodo",
    "OrgpageShowMore",
    "OrgpageShowLess",
    "OrgpageCopiedShort",
    "OrgpageNoRootPaste",
    "OrgpageExportTitle",
    "OrgpageImportTitle",
    "OrgpageExport",
    "OrgpageImport",
    "OrgpageExporting",
    "OrgpageImporting",
    "OrgpageExportComplete",
    "OrgpageImportComplete",
    "OrgpageExportFailed",
    "OrgpageImportFailed",
    "OrgpageImportModuleFailed",
    "OrgpageDownloadZip",
    "OrgpageCancel",
    "OrgpagePause",
    "OrgpageResume",
    "OrgpageImportPaused",
    "OrgpageImportStopping",
    "OrgpageImportCancelled",
    "OrgpageRemovingWrites",
    "OrgpageCleaningImport",
    "OrgpageCancelImportHeader",
    "OrgpageCancelImportAgents",
    "OrgpageCancelImportPipelines",
    "OrgpageCancelImportBoth",
    "OrgpageKeepWrites",
    "OrgpageDeleteWrites",
    "OrgpageStopExport",
    "OrgpageExportCancelled",
    "OrgpageOpenOrganization",
    "OrgpageOrganization",
    "OrgpageOrgName",
    "OrgpageNameTaken",
    "OrgpageNeedsName",
    "OrgpageExportLead",
    "OrgpageReadingOrg",
    "OrgpageImportLead",
    "OrgpageImportPeople",
    "OrgpageKeepContact",
    "OrgpageKeepContactHint",
    "OrgpageAnonymizePeople",
    "OrgpageAnonymizePeopleHint",
    "OrgpageSkipPeople",
    "OrgpageSkipPeopleHint",
    "OrgpageNodes",
    "OrgpageAgents",
    "OrgpageFiles",
    "OrgpageWarningStat",
    "OrgpageWarnings",
    "OrgpageWarningsFromExport",
    "OrgpageExportedWithWarnings",
    "OrgpageImportedWithWarnings",
    "OrgpageReadingZip",
    "OrgpageCouldNotReadZip",
    "OrgpageExportedOrg",
    "OrgpageAgentsToCopy",
    "OrgpagePipelines",
    "OrgpageLocationsStat",
    "OrgpageTriggersStat",
    "OrgpageKnowledgeStat",
    "OrgpageKnowledgeNotExported",
    "OrgpageCheckingAccount",
    "OrgpageWillReuse",
    "OrgpageWillCreate",
    "OrgpageExportWarnings",
    "OrgpageFile",
    "OrgpageLocationCol",
    "OrgpageReason",
    "OrgpageExportTrigger",
    "OrgpageExportModule",
    "OrgpageExportTriggerTitle",
    "OrgpageExportModuleTitle",
    "OrgpageExportTriggerLead",
    "OrgpageExportModuleLead",
    "OrgpageImportOrganization",
    "OrgpageImportTrigger",
    "OrgpageImportModule",
    "OrgpageImportTriggerTitle",
    "OrgpageImportModuleTitle",
    "OrgpageImportTriggerLead",
    "OrgpageImportModuleLead",
    "OrgpageSelectOrgToImport",
    "OrgpageImportParent",
    "OrgpageImportParentPlaceholder",
    "OrgpageNeedsParent",
    "OrgpageNoImportParents",
    "KeineAufzeichnungenGefunden",
    "Laden",
    "Zeige",
    "KeineErgebnisse",
    "ProfileDatabaseAccess",
    "ProfileSsoMicrosoftLogin",
    "ProfileExternalDataSync",
    "CVFilterMainDesc",
    "CVFilterEnable",
    "CVFilterEnableDesc",
    "CVFilterCriteria",
    "CVFilterCriteriaDesc",
    "CVFilterGenerateFromJob",
    "CVFilterJobOfferHint",
    "CVFilterJobOfferPlaceholder",
    "CVFilterGenerating",
    "CVFilterGenerateCriteria",
    "CVFilterOrManually",
    "CVFilterCriterionType",
    "CVFilterSelectType",
    "CVFilterOperator",
    "CVFilterSelectOperator",
    "CVFilterValue",
    "CVFilterSelectLevel",
    "CVFilterAddCriterion",
    "CVFilterAddedCriteria",
    "CVFilterRemoveCriterion",
    "CVFilterNoCriteria",
    "CVFilterMode",
    "CVFilterSourceFilter",
    "CVFilterAllSources",
    "CVFilterAllSourcesDesc",
    "CVFilterExcludeSources",
    "CVFilterExcludeSourcesDesc",
    "CVFilterIncludeSources",
    "CVFilterIncludeSourcesDesc",
    "CVFilterSelectExcludeSources",
    "CVFilterSelectIncludeSources",
    "CVFilterExcludedCount",
    "CVFilterIncludedCount",
    "CVFilterTest",
    "CVFilterTestUploadDesc",
    "CVFilterAnalyzing",
    "CVFilterApiKeyLimit",
    "CVFilterRunTest",
    "CVFilterTestHint",
    "CVFilterNoCriteriaTest",
    "CVFilterExplanation",
    "CVFilterExtractedProfile",
    "CVFilterProfileExperience",
    "CVFilterYears",
    "CVFilterProfileSkills",
    "CVFilterRedFlags",
    "CVFilterCreditsRemaining",
    "ProfileExternalDataSyncDesc",
    "LinkedInSyncMovedToWorkflows",
    "LinkedInSyncMovedToWorkflowsDesc",
    "LinkedInSyncGoToWorkflows",
    "Auswählen",
    "MatchingInformation",
    "GültigBis",
    "LongLivedKeyLimitReached",
    "Permissions",
    "Abmelden",
    "KeineIMAPKonten",
    "KeineSMTPKonten",
    "ProfileDatabaseAccessDesc",
    "ProfileDatabaseAccessIncoming",
    "ProfileDatabaseAccessIncomingEmpty",
    "Annehmen",
    "Ablehnen",
    "Widerrufen",
    "ProfileDatabaseAccessOutgoing",
    "ProfileDatabaseAccessOutgoingEmpty",
    "ProfileSsoDesc",
    "ProfileSsoCompany",
    "ProfileSsoPoolWarning",
    "ProfileSsoCompanyMissing",
    "ProfileSsoDomains",
    "ProfileSsoDomainsHelp",
    "ProfileSsoNoDomains",
    "ProfileSsoAdminConsent",
    "ProfileSsoAdminConsentHelp",
    "ProfileSsoCopyLink",
    "ProfileSsoCopyEmail",
    "AccountLöschen",
    "CVFilterAskMia",
    "Schliessen",
    "Account",
    "IMAPServer",
    "IMAPPort",
    "SMTPServer",
    "SMTPPort",
    "SMTPUsername",
    "SMTPPassword",
    "SMTPFrom",
    "Save",
    "Sicher",
    "AccountWirdGelöscht",
    "Bestätigungscode",
    "CodePerEmailGesendet",
    "AnfrageErhalten",
    "DeletionInfoMsg",
    "OK",
    "LinkedInApplicantSyncActivated",
    "LinkedInApplicantSyncDeactivated",
    "LinkedInApplicantSyncError",
    "LinkedInSyncTargetAtsOn",
    "LinkedInSyncTargetAtsOff",
    "SavingSettings",
    "Warnung",
    "DeleteLongLivedApiKeyConfirm",
    "LongLivedApiKeyDeleted",
    "FehlerBeimLoeschen",
    "WorkflowUpdated",
    "CVFilterIncludeMode",
    "CVFilterExcludeMode",
    "CVFilterJobOfferRequired",
    "CVFilterCriteriaGenerated",
    "CVFilterGenerationFailed",
    "CVFilterUploadRequired",
    "CVFilterCriteriaRequired",
    "CVFilterTestError",
    "CVFilterTestPassed",
    "CVFilterTestRejected",
    "ProfileSsoLoadFailed",
    "ProfileSsoInvalidDomain",
    "ProfileSsoDomainExists",
    "ProfileSsoSaved",
    "ProfileSsoSaveFailed",
    "ProfileSsoLinkCopied",
    "ProfileSsoEmailCopied",
    "Vorschau",
    "Voreingestellt",
    "EigeneFarbe",
    "CVFilterHelpful",
    "CVFilterThanks",
    "CVFilterAskQuestion",
    "CVUploadDragDrop",
    "CVUploadFormats",
    "CVUploadRemove",
    "CVUploadTooLarge",
    "CVUploadInvalidFormat",
    "CVUploadError",
    "BewerberMitProfilMatches",
    "BewerberMitNeutralMatchings",
    "BewerberMitMatches",
    "MehrErfahren",
    "HilfeNichtVerfügbar",
    "CVFilterFreetext",
    "CVFilterExperience",
    "CVFilterSkills",
    "CVFilterEducation",
    "CVFilterLanguages",
    "CVFilterLocation",
    "CVFilterSalary",
    "CVFilterAvailability",
    "CVFilterMinYears",
    "CVFilterMaxYears",
    "CVFilterContainsExp",
    "CVFilterNotContainsExp",
    "CVFilterHasAllSkills",
    "CVFilterHasAnySkill",
    "CVFilterHasNoSkills",
    "CVFilterMinEducation",
    "CVFilterFieldOfStudy",
    "CVFilterHasCertification",
    "CVFilterFluentIn",
    "CVFilterBasicIn",
    "CVFilterNativeLanguage",
    "CVFilterInRegion",
    "CVFilterNotInRegion",
    "CVFilterWillingRelocate",
    "CVFilterMaxSalary",
    "CVFilterSalaryRange",
    "CVFilterAvailableWithin",
    "CVFilterImmediatelyAvailable",
    "CVFilterCustomCriterion",
    "CVFilterNoEducationRequired",
    "CVFilterVocationalTraining",
    "CVFilterBachelor",
    "CVFilterMaster",
    "CVFilterPhD",
    "CVFilterSourceEmail",
    "CVFilterSourceManual",
    "CVFilterSourceWebsite",
    "CVFilterSourceOther",
    "CVFilterEnterValue",
    "CVFilterPlaceholderExperienceMinYears",
    "CVFilterPlaceholderExperienceMaxYears",
    "CVFilterPlaceholderExperienceContains",
    "CVFilterPlaceholderExperienceNotContains",
    "CVFilterPlaceholderSkillsHasAll",
    "CVFilterPlaceholderSkillsHasAny",
    "CVFilterPlaceholderSkillsHasNone",
    "CVFilterPlaceholderEducationMinLevel",
    "CVFilterPlaceholderEducationField",
    "CVFilterPlaceholderEducationHasCertification",
    "CVFilterPlaceholderLanguageFluent",
    "CVFilterPlaceholderLanguageBasic",
    "CVFilterPlaceholderLanguageNative",
    "CVFilterPlaceholderLocationInRegion",
    "CVFilterPlaceholderLocationNotInRegion",
    "CVFilterPlaceholderLocationWillingRelocate",
    "CVFilterPlaceholderSalaryMax",
    "CVFilterPlaceholderSalaryRange",
    "CVFilterPlaceholderAvailabilityWithinDays",
    "CVFilterPlaceholderAvailabilityImmediate",
    "CVFilterPlaceholderCustomCustomCriterion",
    "CVFilterExampleExperienceMinYears",
    "CVFilterExampleExperienceMaxYears",
    "CVFilterExampleExperienceContains",
    "CVFilterExampleExperienceNotContains",
    "CVFilterExampleSkillsHasAll",
    "CVFilterExampleSkillsHasAny",
    "CVFilterExampleSkillsHasNone",
    "CVFilterExampleEducationMinLevel",
    "CVFilterExampleEducationField",
    "CVFilterExampleEducationHasCertification",
    "CVFilterExampleLanguageFluent",
    "CVFilterExampleLanguageBasic",
    "CVFilterExampleLanguageNative",
    "CVFilterExampleLocationInRegion",
    "CVFilterExampleLocationNotInRegion",
    "CVFilterExampleLocationWillingRelocate",
    "CVFilterExampleSalaryMax",
    "CVFilterExampleSalaryRange",
    "CVFilterExampleAvailabilityWithinDays",
    "CVFilterExampleAvailabilityImmediate",
    "CVFilterExampleCustomCustomCriterion",
    "MonaLiveConnected",
    "MonaLiveRedirectHint",
    "MonaLiveOpen",
    "BillingPortalOpening",
    "BillingPortalErrorHeader",
    "BillingPortalError",
    "RichEmailEditorBulletList",
    "DashActivity", "DashAddWidget", "DashAggAvg", "DashAggCount", "DashAggGroup", "DashAggLatest", "DashAggList",
    "DashAggregation", "DashAggSum", "DashAiAssistant", "DashAiConnection", "DashAiDashboardName", "DashAiError",
    "DashAiGreeting", "DashAiPlaceholder", "DashAiSkipped", "DashAiSuggestion1", "DashAiSuggestion2", "DashAiSuggestion3",
    "DashAiSuggestion4", "DashAiTitle", "DashAiTooMany", "DashAiTryAgain", "DashApply", "DashBack", "DashBrowseTemplates",
    "DashCancel", "DashChoosePipeline", "DashChooseTemplate", "DashCollection", "DashColor", "DashCompany",
    "DashCompanyDashboards", "DashCreateWithAi", "DashDataSource", "DashDateField", "DashDateRange", "DashDelete",
    "DashDeleteHeader", "DashDeleteMessage", "DashEmptyGrid", "DashEmptyText", "DashEmptyTitle", "DashErrorFailed",
    "DashErrorForbidden", "DashErrorUnavailable", "DashGroupBy", "DashGroupByHint", "DashIcon", "DashIconHint",
    "DashInvalidWidget", "DashItemsPath", "DashItemsPathHint", "DashLimit", "DashLoading", "DashMyDashboards",
    "DashNamePlaceholder", "DashNewDashboard", "DashNoData", "DashNoDescription", "DashNoPipelines", "DashPipeline",
    "DashPrivate", "DashRange1y", "DashRange24h", "DashRange30d", "DashRange7d", "DashRange90d", "DashRangeAll",
    "DashRefresh", "DashRefreshEvery", "DashRemove", "DashResize", "DashSave", "DashSaveError", "DashSettings",
    "DashSizeFull", "DashSizeLarge", "DashSizeMedium", "DashSizeSmall", "DashSourceCollection", "DashSourcePipeline",
    "DashTemplates", "DashTitle", "DashTotal", "DashTotalLabel", "DashType", "DashUnknownPipeline", "DashUpdatedAt",
    "DashValueField", "DashWidgetCount", "DashWidgetSettings",
    "McpNichtVerfuegbar",
    "McpZugriff",
    "McpServerUrl",
    "McpErlaubteBerechtigungen",
    "McpMeineVerbindungen",
    "McpKeineVerbindungen",
    "McpTrennen",
    "McpVerbindungenFirma",
    "McpNeuVerbindenFuer",
    "McpAnleitung",
    "McpAnleitungClaude",
    "McpAnleitungChatGPT",
    "McpAnleitungRechte",
    "McpExterneServer",
    "McpOhneAuth",
    "McpHeaderName",
    "McpHinzufuegen",
    "McpLesend",
    "McpFreigabe",
    "McpFehler",
    "McpScope_candidates_read",
    "McpScope_candidates_contact",
    "McpScope_jobs_read",
    "McpScope_matching_read",
    "McpScope_matching_write",
    "McpScope_knowledge_read",
    "McpScope_ars_use",
    "McpScopeInfo_candidates_read",
    "McpScopeInfo_candidates_contact",
    "McpScopeInfo_jobs_read",
    "McpScopeInfo_matching_read",
    "McpScopeInfo_matching_write",
    "McpScopeInfo_knowledge_read",
    "McpScopeInfo_ars_use",
    "McpIntegrationen",
    "McpIntTelefon",
    "McpIntTelefonInfo",
    "McpIntKalender",
    "McpIntKalenderInfo",
    "McpIntEmail",
    "McpIntEmailInfo",
    "McpIntAts",
    "McpIntAtsInfo",
    "McpAktiv",
    "McpInaktiv",
    "McpDatenschutz",
    "McpDatenschutzModus",
    "McpDatenschutzInfo",
    "McpKopieren",
    "McpKopiert",
    "McpVerbinden",
    "McpSensibel",
    "McpNurAdmin",
    "McpZuletztGenutzt",
    "McpTrennenFrage",
    "McpTrennenText",
    "McpAbbrechen",
    "McpFertig",
    "McpClaudeSchritt1",
    "McpClaudeSchritt2",
    "McpClaudeSchritt3",
    "McpChatGPTSchritt1",
    "McpChatGPTSchritt2",
    "McpChatGPTSchritt3",
    "McpVerbunden",
    "McpNichtVerbunden",
    "McpSensibelFrage",
    "McpSensibelText",
    "McpSensibelWarnungArs",
    "McpErlauben",
    "McpFreigabeTitel",
    "McpFreigabeText",
    "McpFreigabeJa",
    "McpFreigabeNein",
    "McpFreigabeAusgefuehrt",
    "McpFreigabeAbgelehnt",
    "McpFreigabeAbgelaufen",
    "McpFreigabeFehlgeschlagen",
    "McpFreigabeNichtGefunden",
    "McpFreigabeGueltigBis",
    "McpTool_PHONE_TOOL",
    "McpTool_SMS_TOOL",
    "McpTool_SMTP_TOOL",
    "McpScope_candidates_write",
    "McpScope_jobs_write",
    "McpScope_meetings_read",
    "McpScopeInfo_candidates_write",
    "McpScopeInfo_jobs_write",
    "McpScopeInfo_meetings_read",
    "McpTool_CREATE_CANDIDATE",
    "McpTool_CREATE_JOB_OFFER",
    "McpFehlerNetzwerk",
    "McpFehlerAuth",
    "McpFehlerRechte",
]

